// Lazy load product grid images
function lazyLoadpg(){
    var $images = $('.product-grid-image, .lazy-load-image'); 
    $images.each(function(){
        var $img = $(this),
            src = $img.attr('data-src'); 
        $img
            .attr('src',src);
    });
};
// Toggle search, burger, filter menu on mobile
function showSearchBar() {
  $('html').addClass('search-open');
  $('header .search-bar').addClass('active');  
  $('.search form').addClass('visible');  
}
function showSearchBarDesk() {
  $('html').addClass('search-open');
  $('.header-content.desktop .search-bar').addClass('active');  
  $('.header-content.desktop .search-bar form').addClass('visible');  
}
function hideSearchBarDesk() {
 $('html').removeClass('search-open');
  $('.header-content.desktop .search-bar').removeClass('active');  
  $('.header-content.desktop .search-bar form').removeClass('visible');  
}
function hideSearchBar() {
  $('html').removeClass('search-open');
  $('header .search-bar').removeClass('active');  
  $('.search form').removeClass('visible');  
}
function showMenu() {
  $('.header-content .burger').addClass('active');
  $('nav').addClass('open');
  $('html').addClass('menu-open');
}
function hideMenu() {
  $('.header-content .burger').removeClass('active');
  $('nav').removeClass('open');
  $('html').removeClass('menu-open');  
  $('.submenu-active').removeClass('submenu-active');
}
function showFilterMenu() {
  $('#filters').addClass('active');
  $('.filter-button').addClass('is-open'); // purely visual, no layout change
  $('html').addClass('filters-open');
}
function hideFilterMenu() {
  $('#filters').removeClass('active');
  $('.filter-button').removeClass('is-open');
  $('html').removeClass('filters-open');
}

function resetMobMenu() {
  $('ul.submenu-active').removeClass('submenu-active');
  $('.toggle.submenu-active').removeClass('submenu-active');
}
function pianoBannerClose() {
  $('html').removeClass('piano-sold');
  $('.piano-sold-banner').addClass('hide_banner');
}
function rotatePlusIcon(element) {
  $(element).find('#verticalLine').toggleClass('rotated');
}

function safePendingWishlist() {
  try {
    return JSON.parse(localStorage.getItem('pendingWishlist') || '[]');
  } catch (e) {
    return [];
  }
}

function savePendingWishlist(items) {
  try {
    localStorage.setItem('pendingWishlist', JSON.stringify(items));
  } catch (e) {
    console.error('Could not save pending wishlist:', e);
  }
}

function updateWishlistButton($button, isActive) {
  $button.toggleClass('is-active', isActive);
  $button.attr('data-in-wishlist', isActive ? 'true' : 'false');
  $button.attr('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');

  $button.find('.wishlist-tooltip').text(
    isActive ? 'Remove from wishlist?' : 'Add to wishlist?'
  );

  var variantId = String($button.attr('data-variant-id') || '');
  if (variantId && window.expanded_variants) {
    var variantData = window.expanded_variants[variantId] || window.expanded_variants[Number(variantId)];
    if (variantData) {
      variantData.in_wishlist = isActive;
    }
  }
}

function notifyWishlistDrawer($button) {
  var $card = $button.closest('.grid-item');

  function cleanText($element) {
    if (!$element.length) return '';

    return $.trim(
      $element
        .text()
        .replace(/\s+/g, ' ')
    );
  }

  var price = cleanText(
    $card.find('.product-card-price').first()
  );

  var exVatPrice = cleanText(
    $card.find('.card-extra-exvat em').first()
  );

  if (!$card.length) {
    price = cleanText($('#variant-price .data').first()) || price;
    exVatPrice = cleanText($('#variant-exvat .data:visible').first()) || exVatPrice;
  }

  if (!price) {
    price = $button.attr('data-product-price') || '';
  }

  if (!exVatPrice) {
    exVatPrice = $button.attr('data-product-exvat') || '';
  }

  document.dispatchEvent(new CustomEvent('cm:wishlist-added', {
    detail: {
      productHandle: $button.attr('data-product-handle') || '',
      variantId: $button.attr('data-variant-id') || '',
      title: $button.attr('data-product-title') || '',
      price: price,
      exVatPrice: exVatPrice,
      image: $button.attr('data-product-image') || '',
      sku: $button.attr('data-product-sku') || '',
      stock: $button.attr('data-product-stock') || '',
      productUrl: $button.attr('data-product-url') || ''
    }
  }));
}


$(document).on('click', '.wishlist-toggle', function(e) {
  e.preventDefault();
  e.stopPropagation();

  var $button = $(this);
  var variantId = $button.attr('data-variant-id');
  var isActive = $button.hasClass('is-active');
  var action = isActive ? 'remove' : 'add';

  if (!variantId) {
    console.error('Wishlist failed: missing variant ID');
    return;
  }


  /*
   * Logged-out customer.
   * Store the wishlist locally until they sign in.
   */
  if (!window.siteCustomerId) {
    var pendingWishlist = safePendingWishlist();

    if (action === 'add') {

      if (pendingWishlist.indexOf(String(variantId)) === -1) {
        pendingWishlist.push(String(variantId));
      }

      savePendingWishlist(pendingWishlist);

      updateWishlistButton($button, true);
      notifyWishlistDrawer($button);

    } else {

      pendingWishlist = pendingWishlist.filter(function(id) {
        return String(id) !== String(variantId);
      });

      savePendingWishlist(pendingWishlist);

      updateWishlistButton($button, false);
    }

    return;
  }


  /*
   * Logged-in customer.
   */
  fetch('https://checkout.frederickhyde.com/post/wishlist/' + action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      channel: window.checkoutChannel || 'C',
      customer: {
        id: window.siteCustomerId
      },
      variantId: variantId
    })
  })
  .then(function(r) {
    return r.json();
  })
  .then(function(d) {
    console.log('Wishlist response:', d);

    updateWishlistButton($button, action === 'add');

    /*
     * Only open the drawer when adding.
     * Removing an item should not open it.
     */
    if (action === 'add') {
      notifyWishlistDrawer($button);
    }
  })
  .catch(function(error) {
    console.error('Wishlist error:', error);
  });
});


/*
 * If a visitor added wishlist products before signing in,
 * save those products to their customer wishlist after login.
 */
$(document).ready(function() {
  if (!window.siteCustomerId) return;

  var pendingWishlist = safePendingWishlist();

  if (!pendingWishlist.length) return;

  var requests = pendingWishlist.map(function(variantId) {
    return fetch('https://checkout.frederickhyde.com/post/wishlist/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        channel: window.checkoutChannel || 'C',
        customer: {
          id: window.siteCustomerId
        },
        variantId: variantId
      })
    })
    .then(function(r) {
      if (!r.ok) {
        throw new Error('Wishlist request failed');
      }

      return r.json();
    })
    .then(function(d) {
      console.log('Pending wishlist added:', d);
      return d;
    });
  });


  /*
   * Wait until every locally stored wishlist item has actually
   * been added to the customer's Shopify wishlist.
   */
  Promise.all(requests)
    .then(function() {

      /*
       * Clear this BEFORE reloading so we only reload once.
       */
      localStorage.removeItem('pendingWishlist');


      /*
       * If login has already returned us to the wishlist,
       * reload it so Liquid renders the newly updated metafield.
       */
      if (
        window.location.pathname === '/pages/customer-account' &&
        window.location.hash === '#wishlist'
      ) {
        window.location.reload();
        return;
      }


      /*
       * Otherwise take them directly to their wishlist.
       * The new page load will contain the newly saved items.
       */
      window.location.href = '/pages/customer-account#wishlist';
    })
    .catch(function(error) {
      console.error('Pending wishlist error:', error);
    });
});

$( document ).ready(function(){
  lazyLoadpg();
  if (window.prefers_so_variant_id) {
    var currentInput = document.getElementById('variant-id');
    if (currentInput && String(currentInput.value) !== String(window.prefers_so_variant_id)) {
      if (typeof updateVariant === 'function' && window.expanded_variants) {
        updateVariant(window.prefers_so_variant_id);
      } else {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', window.prefers_so_variant_id);
          window.location.href = url.toString();
        } catch (e) {
          window.location.href = window.location.pathname + '?variant=' + window.prefers_so_variant_id;
        }
      }
    }
  }
  $('.header-content .burger').on('click',function() {
    if ($(this).hasClass('active')) {
      hideMenu();
    } else {
      showMenu();
      hideSearchBar();
      hideFilterMenu();
    }
  });
  $('.filter-button').on('click',function() {
    if ($(this).hasClass('is-open')) {
      hideFilterMenu();
    } else {
      showFilterMenu();
      hideSearchBar();
      hideMenu();
    }
  });  
  $('.close-mobile-menu').on('click',function() {
    hideMenu();
  });
  
  $('html').on('click', '#filters > h2 .close, #filters .filter-close', function(e){
  e.preventDefault();
  hideFilterMenu();
});
$('#filters').on('click touchstart touchend', function(e){ e.stopPropagation(); });

// Block background scroll while open (safe on mobile)
document.addEventListener('touchmove', function(e){
  if ($('html').hasClass('filters-open') && !$(e.target).closest('#filters').length){
    if (e.cancelable) e.preventDefault();
  }
}, { passive:false });

 $('header .search').on('click touch',function(e) {
  if ($(this).closest('.header-content.desktop.hc, .header-content.desktop.mh').length && $('#expanding-desktop-search-form').length) {
    return;
  }

  if (!($(e.target).parents('#results-box').length)) {
    if ($(this).hasClass('active')) {
      if (!($(e.target).is('#search-input-box')) && !($(e.target).is('#search-input-box ~ button')) && !($(e.target).is('#search-input-box ~ button svg'))) {
        hideSearchBar();
      }
    } else {
      showSearchBar();
      if($(e.target).parents('.header-icons').length) {
        $('#search-input-box').focus();
      }
      hideMenu();
      hideFilterMenu();
    }
  }
});
  $('#tint').click(function() {
      hideFilterMenu();
      hideSearchBar();
      hideMenu();
      resetMobMenu();
  });
  (function($){
  const BP = 1000;  
  let lastW = window.innerWidth;

  const debounce = (fn, ms) => {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this,args), ms); };
  };

  $(window).on('resize', debounce(function(){
    const w = window.innerWidth;
    const crossedToDesktop = (lastW < BP && w >= BP);
    const crossedToMobile  = (lastW >= BP && w < BP);
    lastW = w;

    // Only do hard closes when we actually switch layout bands
    if (crossedToDesktop) {
      hideFilterMenu();
      hideMenu();
      resetMobMenu();
      hideSearchBar();
    }

    // DO NOT close filters for tiny resizes caused by the mobile URL bar
    // (and never close if the user currently has filters open)
    // if ($('html').hasClass('filters-open')) return; // optional extra guard
  }, 150));
})(jQuery);

});


// Shopify forms styling
document.addEventListener('DOMContentLoaded', () => {
  const formContainer = document.querySelector('#app-embed');

  const observer = new MutationObserver((mutationsList, observer) => {
  const form = document.querySelector('form-embed');

if (form) {
  observer.disconnect();
  const shadow = form.shadowRoot;

  const sheet = new CSSStyleSheet();
  sheet.insertRule(`
    ._formContainer_stahb_30 {
      max-width: 900px!important;
    }
  `);

  shadow.adoptedStyleSheets.push(sheet);
  formContainer.classList.add('loaded');
}
});

observer.observe(document.body, { childList: true, subtree: true });
});


// Paging through mobile menu
$(document).ready(function () {
  $('ul.mega-menu.mobile li .toggle').click(function () {
    if ($(this).hasClass('submenu-active')) {
      $(this).removeClass('submenu-active');
      $(this).parents('.has-sublink').next('ul').removeClass('submenu-active');
    } else {
      $(this).addClass('submenu-active');
      $(this).parents('.has-sublink').next('ul').addClass('submenu-active');
    }
  });
});
//rotate plus icon
$(document).ready(function () {
  $('.plus-icon.toggle').click(function () {
    rotatePlusIcon(this);
  });
});

  
// Trigger the add to cart when pressing enter from the quantity box
$( document ).ready(function(){
  $('#quantity').bind('keypress', function(e) {
      if(e.keyCode==13){
        addToAjaxCart($('#ajax-cart-button'));
      }
  });
});

// Trigger tint for Piano Sold banner
$(document).ready(function() {
  if ($('#add-to-basket').hasClass('piano-sold')) {
    $('html').addClass('piano-sold');
  }
});

// Slick sliders
function productImgSlick() {
  $('#product-images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    asNavFor: '#product-images-small',
    mobileFirst:true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 690, 
        settings: {
          dots: false,
          arrows: true
        }
      }
    ]
  });
  $('#product-images-small').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '#product-images',
    dots: false,
    arrows: false,
    mobileFirst: true,
    adaptiveHeight: false,
    focusOnSelect: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 690,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  });  
}
function carouselSlick(e) {
  $(e).slick({    
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '0px',
    cssEase: 'linear',
    centerMode:true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1243,
        settings: {
          slidesToShow: 4,
    	  slidesToScroll: 4,
          arrows: true,
          dots: false
        }
      },
      {
        breakpoint: 902,
        settings: {
          slidesToShow: 3,
    	  slidesToScroll: 3,
          arrows: true,
          dots: false
        }
      },
      {
        breakpoint: 648,
        settings: {
          slidesToShow: 2,
    	  slidesToScroll: 2,
          arrows:false,
          dots: true
        }
      }
    ]
  });
} 
// Sort an object by key
function sortObjectByKeys(o) {
  return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
}    
// Update a query parameter
function updateQueryString(k,v) {
  var urlParams = new URLSearchParams(window.location.search);
  urlParams.set(k,v);
  return urlParams.toString().replace(/\+/g,'%20');
}
// Update a query parameter without reloading
function insertUrlParam(key, value) {
  if (history.replaceState) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
    window.history.replaceState({ path: newurl }, '', newurl);
  }
}
// Pad a number with zeroes and change to string
function pad(str,max) {
  str = str.toString();
  return str.length < max ? pad("0" + str, max) : str;
}
// Add commas to numbers
function numberWithCommas(number) {
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (parts.length > 1 && parts[1].toString().length < 2) {
      parts[1] = parts[1].toString() + '0';
    }
    return parts.join(".");
}

async function loadSelectContents(url) {
  var dfd = $.Deferred();

  currReqObj = $.ajax({
    url: url,
    data: {
      view: 'variant-select-options'
    },
    dataType: 'html',
    success: function(data) {
      dfd.resolve(data);
    },
    error: function(xhr, status, error) {
      console.error('Variant select failed to load:', status, error);
      dfd.resolve(null);
    }
  });

  return dfd.promise();
}

// Fetch variant data on-demand
async function fetchVariantData(variantId) {
  try {
    // Get product handle from first variant or URL as fallback
    const firstVariantId = Object.keys(expanded_variants)[0];
    const productHandle = (expanded_variants[firstVariantId]?.product_handle) 
      || window.location.pathname.split('/products/')[1]?.split('?')[0];
    
    if (!productHandle) {
      console.error('Could not determine product handle');
      return null;
    }
    
    const response = await fetch(
      `/products/${productHandle}?variant=${variantId}&section_id=variant-data-api`
    );
    const html = await response.text();
    
    // Parse the JSON from the section
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const jsonData = JSON.parse(tempDiv.textContent);
    
    return jsonData[variantId];
  } catch (error) {
    console.error('Failed to fetch variant data:', error);
    return null;
  }
}

// Update all the product page info as different variant selected from dropdown
async function updateVariant(newId) {
  // Load variant data if not already cached
  if (!expanded_variants[newId]) {
    const variantData = await fetchVariantData(newId);
    if (variantData) {
      expanded_variants[newId] = variantData;
    } else {
      console.error('Could not load variant data for:', newId);
      return;
    }
  }
  
  var newVar = expanded_variants[newId];
  var SelectContents = await loadSelectContents(
    '/products/' + newVar.product_handle + '?variant=' + newId
  );

  if (SelectContents) {
    $('#variant-selection').html(SelectContents);
  }
  if (newVar.condition_description.length > 0) {
    $('.condition-select').after('<span id="condition_description">' + newVar.condition_description + '</span>').show();
    $('#condition_description, .was_discount').addClass(newVar.condition_title);
  } else {
    $('#condition_description').hide();
  }
  // Load tags from 1000 results for filter population, passed page number
  // update the sku and variant id
  insertUrlParam('variant',newVar.id);
  $('#variant-info .sku .data').text(newVar.sku);
  if (newVar.title && String(newVar.title).trim().toLowerCase() !== 'default title') {
    $('#product-title .variant, #slide-title .variant').text(' - ' + newVar.title);
  } else {
    $('#product-title .variant, #slide-title .variant').text('');    
  }
  $('#variant-id').val(newVar.id);
  // update the main price
  $('#variant-price .data, #slide-variant-price .data, #priceForFinance').text(newVar.price_display);
  $('#variant-price .rrp-discount, #slide-variant-price .rrp-discount').text(newVar.trade_discount);
  // show/hide the exvat price if it's different. Suppressed entirely when we
  // don't collect tax for the visitor's market (window.collectingTax, set in
  // theme.liquid) - the main price is already ex VAT there
  var showExVat = window.collectingTax !== false && newVar.exvat && newVar.exvat !== newVar.price_display;
  if (showExVat) {
    $('#variant-exvat .vat').show();
    $('#variant-exvat .data, #slide-variant-exvat').text(newVar.exvat).show();
  } else {
    $('#variant-exvat .vat').hide();
    $('#variant-exvat .data, #slide-variant-exvat').text(newVar.exvat).hide();
  };

  if (window.CMProductSupport && typeof window.CMProductSupport.setVariant === 'function') {
    window.CMProductSupport.setVariant(newVar);
  }

  // add the Flash Sale price
  if (Number(newVar.flash_sale) > 0) {
    $('#variant-price .sale')
      .text(
        '£' + (Number(newVar.flash_sale) / 100).toLocaleString('en-GB', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        })
      )
      .show();
  } else {
    $('#variant-price .sale').text('').hide();
  }
  // add the Partner Price
  $('#partner-price .data').text(newVar.partner_price);

if (newVar.was_price) {
  $('#variant-price .was_price').text(newVar.was_price).show();
} else {
  $('#variant-price .was_price').text('').hide();
}


// hide buy UI when sold out, or when this market has no inventory context
if (newVar.is_sold_out === 'true' || newVar.unavailable_in_country === true) {
  $('#add-to-basket, .product-bullets, .available-from, .product-page-usp, .dis').hide();
  $('.cm-product-advantage-panel').hide();
  $('#slide-buy-box').removeClass('active');
  $('#unavailable-in-country-note').prop('hidden', newVar.unavailable_in_country !== true);
  if (newVar.is_sold_out === 'true') {
    $('.data.stock, .data.custom-text').addClass('sold-out');
    $('#product .promos').css('grid-row', '8');
  } else {
    $('.data.stock, .data.custom-text').removeClass('sold-out');
    $('#product .promos').css('grid-row', '');
  }
} else {
  $('#add-to-basket, .product-bullets, .available-from, .product-page-usp, .dis').show();
  $('.data.stock, .data.custom-text').removeClass('sold-out');
  $('#product .promos').css('grid-row', '');
  $('#unavailable-in-country-note').prop('hidden', true);
}

  window.QtyCap.applyFromExpanded(newId);



  // update the RRP and show it if it's different from our price
  if (newVar.rrp > parseInt(newVar.price) || false || newVar.partner_pricing === 'true' ) {
    $('#variant-rrp .data').text(newVar.rrp_display).show();
    $('#variant-rrp .label').show();
  } else {
    $('#variant-rrp .data').text(newVar.rrp_display).hide();
    $('#variant-rrp .label').hide();
  }
  
  if (newVar.rrp_display === 0) {
    $('#variant-rrp .data').hide();
    $('#variant-rrp .label').hide();
  }
   
  // update the stock levels
 $('#variant-stock .data.stock').html(newVar.stock_display);

 $('.was_discount_brackets').html(newVar.was_price_discount + '% off');

 // render the was_price_discount on product pages
$('.was_discount').remove();

var $sel = $('.condition-select input[name="var_condition"]:checked').closest('label.condition');
var isA1  = $sel.hasClass('new');
var isDIS = $sel.hasClass('on-display');

if ($sel.length && newVar.was_price && !isA1 && !isDIS) {
  $('<span class="was_discount">' + newVar.was_price_discount + '% off RRP</span>')
    .insertAfter($sel)
    .addClass(newVar.condition_title);
}

  if (newVar.unavailable_in_country === true) {
    $('#variant-stock .data.pors span').remove();
    $('#variant-stock .data.fromto').html('');
    $('#variant-stock .data.stock').removeClass('has-date');
    $('#variant-stock .data.pors').removeClass('instock');
  } else if (newVar.pors.length > 0) {
    $('#variant-stock .data.pors').html('<span>' + newVar.pors + '</span>'); 
    $('#variant-stock .data.fromto').html(''); // Hide fromto if pors exists
  } else {
    $('#variant-stock .data.pors span').remove();
    $('#variant-stock .data.fromto').html(newVar.manufacturer_fromto); // Show fromto if no pors
  }
  
  if (newVar.unavailable_in_country !== true && !$('#variant-stock .data.stock .green').hasClass('alwaysinstock') && (newVar.stock_level < 1 || newVar.pors.length > 0)) {
    $('#variant-stock .data.stock').addClass('has-date');
  } else if (newVar.unavailable_in_country !== true) {
    $('#variant-stock .data.stock').removeClass('has-date');
  }

  if (newVar.unavailable_in_country !== true && $('#variant-stock .data.stock .red').hasClass('alwaysinstock') && (newVar.stock_level < 1 || newVar.pors.length > 0)) {
    $('#variant-stock .data.stock').removeClass('has-date');
  }
  
  if (newVar.unavailable_in_country !== true && newVar.stock_level >= 1) { 
    $('#variant-stock .data.pors').addClass('instock')
  } else {
    $('#variant-stock .data.pors').removeClass('instock')
  }
  
  //Add sheet music bullets 
  $('#sheet-bullet').html(newVar.sheet_bullets).show();
  
  // Update the shipping info
  $('#variant-delivery .data.shipping-group').html(newVar.shipping_group);
  $('#variant-delivery .data.custom-text').html(newVar.custom_text);



  // On display badge beside the stock level. Not shown when the chosen
  // condition is already On display (DIS), which says so itself.
  if (newVar.on_display && newVar.condition_title !== 'on-display') {
    $('#variant-stock .data.display-badge').html('<span>On display</span>');
  } else {
    $('#variant-stock .data.display-badge').empty();
  }

  // Show NEW flag
  $('.promo-tag.new').toggleClass('new-product', newVar.new_product);

  // Toggle Double and Triple point flags
  $('.promo-tag.double-points').toggleClass('advantage-double', Number(newVar.advantage_points_multiplier) === 2);
  $('.promo-tag.triple-points').toggleClass('advantage-triple', Number(newVar.advantage_points_multiplier) === 3);

  // Update min purchase 
   if (newVar.min_purchase && newVar.min_purchase !== "0") {
        $('#quantity').val(newVar.min_purchase);
        $('.min-purchase')
            .html(`<strong>Minimum purchase: ${newVar.min_purchase}</strong>`)
            .show(); 
    } else {
        $('#quantity').val(1);
        $('.min-purchase').hide(); 
    }if (newVar.qbreakString && newVar.qbreakString.trim() !== "") {
        // Parse the HTML string into a jQuery object
        var htmlString = newVar.qbreakString;
        var $breaks = $(htmlString);    
        // Sort the divs based on the quantity
        $breaks.sort(function(a, b) {
            // Extract the quantity from the spans
            var quantityA = parseInt($(a).find('.quantity').text());
            var quantityB = parseInt($(b).find('.quantity').text());    
            // Sort in ascending order
            return quantityA - quantityB;
        });    
        // Update the HTML of the quantity-breaks element with sorted divs
        $('#quantity-breaks').html($breaks);
    } else {
      $('#quantity-breaks').html(newVar.qbreakString);
    }// build the image html from a list of URLs
  $('#product-images').has('.slick-slide').slick('unslick');
  $('#product-images').empty();
  $('#product-images-small').has('.slick-slide').slick('unslick');
  $('#product-images-small').empty();
  function appendSpinSlide() {
  if (!newVar.spin_frames || !newVar.spin_frames.length) return;

  var firstSpin = newVar.spin_frames[0].url;
  var spinData = encodeURIComponent(JSON.stringify(newVar.spin_frames));

  $('#product-images').append(
    '<div class="slide spin-slide" data-slide-number="' + media_tally + '">' +
      '<div class="spin-viewer js-spin-viewer" data-spin-index="0" data-frames="' + spinData + '">' +
        '<div class="spin-instruction">Click to view full screen</div>' +
        '<img draggable="false" src="' + firstSpin + '" alt="360 product view">' +
      '</div>' +
    '</div>'
  );

  media_tally = media_tally + 1;
}


function appendSpinThumb() {
  if (!newVar.spin_frames || !newVar.spin_frames.length) return;

  var firstSpin = newVar.spin_frames[0].url;
  var spinThumbUrl = firstSpin;

  if (newVar.spin_thumb && newVar.spin_thumb.length > 0) {
    spinThumbUrl = newVar.spin_thumb[0].url;
  }

  $('#product-images-small').append(
    '<div class="slide spin-thumb" data-slide-number="' + thumb_tally + '">' +
      '<span class="spin-thumb-badge"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 162.49 145.2"><defs><style>.st2{fill:#fff}.st3{fill:#f7032e}</style></defs><path d="M107.21 114.71v27.01c1.91-.36 3.8-.76 5.66-1.2 9.67-2.29 18.36-5.56 25.82-9.74 7.46-4.17 13.32-9.03 17.41-14.44 4.24-5.6 6.39-11.55 6.39-17.69V71.64c0 5.31-1.61 10.48-4.79 15.41-.49.77-1.02 1.52-1.59 2.28-4.09 5.41-9.95 10.27-17.41 14.44s-16.15 7.45-25.82 9.74c-1.87.44-3.76.84-5.66 1.2Z" class="st3"/><path d="M0 71.64c0 5.31 1.61 10.48 4.79 15.41 9.14-18.82 39.95-32.7 76.46-32.7s67.32 13.88 76.45 32.69c3.18-4.93 4.79-10.1 4.79-15.41 0-6.14-2.15-12.09-6.39-17.69-4.09-5.41-9.95-10.27-17.41-14.44s-16.15-7.45-25.82-9.74c-10.02-2.37-20.66-3.57-31.63-3.57s-21.61 1.2-31.63 3.57c-9.67 2.29-18.36 5.56-25.83 9.74-7.46 4.17-13.32 9.03-17.41 14.44-4.24 5.6-6.39 11.55-6.39 17.69Z" style="fill:#bc032e"/><path d="M0 71.64v27.01c0 6.13 2.15 12.08 6.39 17.69 4.09 5.41 9.95 10.27 17.41 14.44 5.71 3.19 12.13 5.86 19.17 7.96v6.46l10.42-3.85 27.86-11.4-21.88-14.53-16.4-10.9v7.21c-7.04-2.1-13.46-4.77-19.17-7.96-7.46-4.17-13.32-9.03-17.41-14.44-.57-.75-1.1-1.51-1.59-2.27C1.62 82.13.01 76.96.01 71.65Z" class="st3"/><circle cx="81.84" cy="55.88" r="55.88" style="fill:#252a66"/><path d="m62.65 47.2 2.92-19.85h3.51l-3.75 24.33h-5.7l-3.75-24.33h3.86l2.92 19.85ZM70.83 27.35h3.82v24.33h-3.82zM80.8 37.61h5.25v3.48H80.8v7.13h6.6v3.48H76.97V27.37H87.4v3.48h-6.6v6.78ZM98.38 38.72l-1.39 12.96h-5.25l-2.71-24.33h3.72l2.05 19.19 1.84-19.19h3.68l1.91 19.33 1.98-19.33h3.34l-2.71 24.33h-5.08l-1.39-12.96ZM68.09 64.46c0-1.21-.2-2.03-.6-2.45s-.93-.64-1.6-.64-1.2.2-1.6.6q-.6.6-.6 2.07v1.74h-4.02v-1.47c0-2.19.53-3.87 1.6-5.04s2.65-1.76 4.73-1.76 3.66.59 4.73 1.76 1.6 2.85 1.6 5.04v.7c0 2.88-.99 4.74-2.98 5.56 1.08.46 1.85 1.18 2.3 2.14.45.97.68 2.14.68 3.54v2.12c0 2.19-.54 3.87-1.6 5.04-1.07 1.17-2.65 1.76-4.73 1.76s-3.66-.59-4.73-1.76-1.6-2.85-1.6-5.04v-2.24h4.02v2.51q0 1.47.6 2.07c.4.4.93.6 1.6.6s1.2-.21 1.6-.62q.6-.615.6-2.43v-2.12q0-1.89-.66-2.67c-.44-.51-1.15-.77-2.12-.77h-1.43v-3.86h1.66c.8 0 1.42-.21 1.87-.62s.68-1.16.68-2.24v-1.51ZM74.54 64.54c0-2.29.53-4.04 1.58-5.24 1.06-1.2 2.69-1.8 4.91-1.8 2.09 0 3.66.59 4.73 1.76s1.6 2.85 1.6 5.04v.7h-4.02v-.97q0-1.47-.6-2.07c-.6-.6-.93-.6-1.6-.6-.75 0-1.33.23-1.74.7-.41.46-.62 1.34-.62 2.63v4.95c.75-1.6 2.06-2.4 3.94-2.4 1.57 0 2.75.53 3.54 1.58.79 1.06 1.18 2.59 1.18 4.6v4.95c0 2.19-.55 3.87-1.66 5.04s-2.7 1.76-4.79 1.76-3.68-.59-4.79-1.76-1.66-2.85-1.66-5.04zM81 71.11c-.67 0-1.2.2-1.6.6q-.6.6-.6 2.07v4.87c0 .98.2 1.66.6 2.05s.93.58 1.6.58 1.2-.19 1.6-.58.6-1.07.6-2.05v-4.87q0-1.47-.6-2.07c-.6-.6-.93-.6-1.6-.6M89.52 64.31c0-2.19.55-3.87 1.66-5.04s2.7-1.76 4.79-1.76 3.68.59 4.79 1.76 1.66 2.85 1.66 5.04v14.06c0 2.19-.55 3.87-1.66 5.04s-2.7 1.76-4.79 1.76-3.68-.59-4.79-1.76-1.66-2.85-1.66-5.04zm4.25 14.33q0 1.47.6 2.07c.4.4.93.6 1.6.6s1.2-.2 1.6-.6.6-1.09.6-2.07v-14.6q0-1.47-.6-2.07c-.6-.6-.93-.6-1.6-.6s-1.2.2-1.6.6q-.6.6-.6 2.07z" class="st2"/><path d="M108.21 63.63c-.73 0-1.38-.16-1.96-.48s-1.03-.75-1.36-1.31c-.33-.55-.5-1.19-.5-1.89s.17-1.36.5-1.91.78-.98 1.36-1.3c.57-.32 1.23-.48 1.96-.48s1.4.16 1.98.48 1.03.75 1.36 1.3.49 1.18.49 1.91-.16 1.35-.49 1.9-.78.99-1.36 1.3q-.87.48-1.98.48Zm0-1.42c.41 0 .78-.09 1.1-.28.32-.18.58-.45.76-.79s.28-.74.28-1.19-.09-.85-.28-1.19-.44-.6-.76-.78-.68-.28-1.09-.28-.77.09-1.09.28c-.32.18-.58.44-.77.78s-.28.73-.28 1.19.09.84.28 1.19c.19.34.44.61.77.79.32.18.68.28 1.08.28Z" style="stroke:#fff;stroke-miterlimit:10;stroke-width:.39px;fill:#fff"/></svg></span>' +
      '<img draggable="false" src="' + spinThumbUrl + '" alt="360 product view">' +
    '</div>'
  );

  thumb_tally = thumb_tally + 1;
}
  let media_tally = 0;
  let thumb_tally = 0;

  /* Main images */
  $.each(newVar.images, function(i, e) {
    $('#product-images').append(
      '<div class="slide" data-slide-number="' + media_tally + '">' +
        '<div class="fullscreen-button"></div>' +
        '<img src="' + e.url + '" alt="' + e.alt + '" style="aspect-ratio:' + e.aspect + ';">' +
      '</div>'
    );

    media_tally = media_tally + 1;

    if (i === 0) {
      appendSpinSlide();
    }
  });

  /* Thumbs */
  $.each(newVar.thumbs, function(i, e) {
    $('#product-images-small').append(
      '<div class="slide" data-slide-number="' + thumb_tally + '">' +
        '<img src="' + e.url + '" alt="' + e.alt + '" style="aspect-ratio:' + e.aspect + ';">' +
      '</div>'
    );

    thumb_tally = thumb_tally + 1;

    if (i === 0) {
      appendSpinThumb();
    }
});
  $.each(newVar.videos, function(i,e){
    $('#product-images').append('<div class="slide video" data-slide-number="' + media_tally + '"><div class="video-spacer">' + e.code + '</div></div>');
    $('#product-images-small').append('<div class="slide video-thumb" data-slide-number="' + thumb_tally + '"><img src="' + e.url + '" alt="' + e.alt + '"></div>');
    media_tally = media_tally + 1;
    thumb_tally = thumb_tally + 1;
  });
productImgSlick();

setTimeout(function() {
  $('#product-images .js-spin-viewer').each(function() {
    if (!$(this).closest('#spin-fullscreen').length) {
      startSpinViewer($(this));
    }
  });
}, 100);

$('#images .fullscreen-button').attr('onclick','photoswipe(\'' + newVar.id + '\');');

  // replace crosssell variant blocks


   $('#prod-usp .free-delivery').hide();
  if (newVar.price >= 5000 && newVar.shipping_group == '' ) {
      $('#prod-usp .free-delivery').show();
  } 
   $('#prod-usp .despatch').hide();
  if (newVar.stock_level > 0 ) {
      $('#prod-usp .despatch').show();
  } 
  
  // replace similar items carousel contents
  $('.product-carousel.similar-items').has('.slick-slide').slick('unslick');
  $('.product-carousel.similar-items').empty();
  $('.product-carousel.similar-items').append(newVar.similar_items);
  carouselSlick('.product-carousel.similar-items');
  lazyLoadpg();


// replace compatible products carousel contents
var $compatible = $('.compatible-variant-carousel');

if ($compatible.length) {
  if ($compatible.hasClass('slick-initialized')) {
    $compatible.slick('unslick');
  }

  $compatible.empty();

  if (newVar.compatible_products && newVar.compatible_products.trim().length > 0) {
    $compatible.append(newVar.compatible_products);
    $compatible.closest('.section-full-width').show();
    compatibleProductsSlick($compatible);
  } else {
    $compatible.closest('.section-full-width').hide();
  }
}

lazyLoadpg();
}


// Add download icon to piano manuals
$( document ).ready(function(){
    var $links = $('.piano-manual-in-description, .manual-in-description, .dealer-assets').not('.sxp, .beatlife');
    $links.each(function(){ 
      $(this).append('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="rollover-block" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 19.54 14.57" style="enable-background:new 0 0 19.54 14.57;" xml:space="preserve"><g><g><g><polygon points="9.77,10.97 0,1.2 1.2,0 9.77,8.57 18.34,0 19.54,1.2"/></g></g><g><rect x="0.26" y="12.87" width="19.03" height="1.7"/></g></g></svg>');
    });
});

$( document ).ready(function(){
    var $links = $('.manual-in-description.sxp, .manual-in-description.beatlife');
    $links.each(function(){ 
      $(this).append('<svg version="1.1" x="0px" y="0px" width="12px" class="rollover-block" height="20.5px" viewBox="0 0 12 20.5" style="enable-background:new 0 0 12 20.5;" xml:space="preserve"> <g> <g> <polygon points="1.7,20 0.5,18.8 9.1,10.3 0.5,1.7 1.7,0.5 11.5,10.3 "/> </g> </g> </svg>');
    });
});

// function for carousel slick initialization
function carouselSlick(selector) {
    $(selector).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1324,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: false,
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                }
            }
        ]
    });
}

function compatibleProductsSlick(selector) {
  var $carousel = $(selector);

  if (!$carousel.length || !$carousel.children('.slide').length) return;

  if ($carousel.hasClass('slick-initialized')) {
    $carousel.slick('unslick');
  }

  var isFrederickHyde = window.location.hostname.indexOf('frederickhyde') !== -1;

  var slickSettings = isFrederickHyde ? {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1143,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 859,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: false
        }
      }
    ]
  } : {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1183,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: false
        }
      },
      {
        breakpoint: 970,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false
        }
      },
      {
        breakpoint: window.themeBreakpointTiny || 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 329,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: false,
          dots: true
        }
      }
    ]
  };

  $carousel.slick(slickSettings);

  if (typeof lazyLoadpg === 'function') {
    lazyLoadpg();
  }
}

// function for adding to cart
function addToAjaxCart(button) {
  var variantid= $('#variant-id').val();
  var variantData = window.expanded_variants && (
    window.expanded_variants[variantid] || window.expanded_variants[Number(variantid)]
  );
  if (!variantData || variantData.unavailable_in_country === true) {
    return;
  }

  button.html('<img src="//www.huskcups.co.uk/cdn/shop/t/2/assets/preloader.gif?v=77008736554601496081763466763">');

  var rawQty   = parseInt($('#quantity').val(), 10);
  var addQty   = isNaN(rawQty) || rawQty < 1 ? 1 : rawQty;
  var stocklevel  = variantData.stock_level;
  var overselling = variantData.stock_policy;  
  var qbreaks     = variantData.quantity_breaks;
  if (qbreaks != null && typeof qbreaks !== 'string') qbreaks = JSON.stringify(qbreaks);

  var alwaysInStock =
    variantData.always_in_stock === true;

  var wishlistStock =
    variantData.wishlist_stock ||
    (
      stocklevel > 0 || alwaysInStock
        ? 'In stock'
        : 'Available to order'
  );

  if (overselling === 'deny' && addQty > stocklevel) addQty = stocklevel;

  // DR-0091: a variant that collects artwork posts its file with the line
  // (multipart, public "Artwork" property). The product page keeps both
  // Add to basket buttons off until a file is chosen, so this only guards.
  var artworkApi = window.CMProductArtwork;
  var artworkFile = (artworkApi && artworkApi.requires(variantid)) ? artworkApi.file() : null;
  if (artworkApi && artworkApi.requires(variantid) && !artworkFile) {
    button.html('Add to basket');
    $('#fading-message')
      .html('<span>Choose your artwork file first</span>')
      .addClass('show red');
    return;
  }

  jQuery.get('/cart.js', function(cartData) {
    var parsedCart = JSON.parse(cartData);
    variantid = parseInt(variantid, 10);

    let existingItem = null;
    let existingQuantity = 0;

    $(parsedCart.items).each(function(i, item) {
      var properties = item.properties || {};
      var systemManaged = properties._offer_reward || properties._required_extra || properties._customisation_extra;
      if (item.variant_id === variantid && !systemManaged) {
        existingItem = item;
        existingQuantity = item.quantity;
        return false; // break
      }
    });

    if (existingItem) {
      let desired = existingQuantity + addQty;
      let absoluteQty = (overselling === 'deny')
        ? Math.min(desired, stocklevel)
        : desired;

      if (absoluteQty <= existingQuantity) {
        button.css('display','none');
        $('#fading-message')
          .html('<span>You have all our remaining stock in your basket</span><a class="button" href="/cart">Go to basket</a>')
          .addClass('show red');
        return;
      }

      const updateParams = {
        id: existingItem.key,   
        quantity: absoluteQty,      
        properties: Object.assign({}, existingItem.properties || {}, {
          _stocklevel: stocklevel,
          _stockpolicy: overselling,
          _qbreaks: qbreaks,
          _always_in_stock: alwaysInStock ? 'true' : 'false',
          _wishlist_stock: wishlistStock
        })
      };

      if (artworkFile && window.HuskeeCustomJob) {
        // Merge into the existing folder line, replacing its artwork with the new file
        window.HuskeeCustomJob
          .replaceArtwork(existingItem.key, artworkFile, updateParams.properties, absoluteQty, variantid)
          .then(body => { handleCartResponse(cartResponseFromBody(body), button, overselling); })
          .catch(error => { artworkCartError(error, button); });
        return;
      }

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updateParams)
      })
      .then(response => { handleCartResponse(response, button, overselling); })
      .catch((error) => { console.error('Error:', error); button.html('Add to basket'); });

    } else {
      // New line
      let absoluteQty = (overselling === 'deny')
        ? Math.min(addQty, stocklevel)
        : addQty;

      if (absoluteQty <= 0) {
        button.css('display','none');
        $('#fading-message')
          .html('<span>Sorry, this item just sold out</span><a class="button" href="/cart">Go to basket</a>')
          .addClass('show red');
        return;
      }

      const params = {
        items: [{
          id: variantid,
          quantity: absoluteQty,
          properties: {
            _stocklevel: stocklevel,
            _stockpolicy: overselling,
            _qbreaks: qbreaks,
            _always_in_stock: alwaysInStock ? 'true' : 'false',
            _wishlist_stock: wishlistStock
          }
        }]
      };

      if (artworkFile && window.HuskeeCustomJob) {
        // New folder line with the artwork file as the public Artwork property
        window.HuskeeCustomJob
          .cartAddForm(variantid, absoluteQty, params.items[0].properties, artworkFile, 'Artwork')
          .then(body => { handleCartResponse(cartResponseFromBody(body), button, overselling); })
          .catch(error => { artworkCartError(error, button); });
        return;
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
      })
      .then(response => { handleCartResponse(response, button, overselling); })
      .catch((error) => { console.error('Error:', error); button.html('Add to basket'); });
    }
  });
}

// DR-0091: the Huskee helpers resolve with the parsed cart body (they throw
// on a non-2xx), so wrap it to look like the Response handleCartResponse expects.
function cartResponseFromBody(body) {
  return { status: 200, ok: true, json: function () { return Promise.resolve(body); } };
}

function artworkCartError(error, button) {
  console.error('Error:', error);
  button.html('Add to basket');
  $('#fading-message')
    .html('<span>' + $('<div>').text((error && error.message) || 'Could not add to basket.').html() + '</span>')
    .addClass('show red');
}

function getSpinFrames($viewer) {
  try {
    return JSON.parse(decodeURIComponent($viewer.attr('data-frames') || '[]'));
  } catch (e) {
    return [];
  }
}

function startSpinViewer($viewer) {
  var frames = getSpinFrames($viewer);
  if (!frames.length) return;

  var index = Number($viewer.attr('data-spin-index') || 0);
  var $img = $viewer.find('img').first();

  clearInterval($viewer.data('spinTimer'));

  var timer = setInterval(function() {
    index++;

    if (index >= frames.length) {
      index = 0;
    }

    $img.attr('src', frames[index].url);
    $viewer.attr('data-spin-index', index);
  }, 100);
  
  $viewer.data('spinTimer', timer);
}
function stopSpinViewer($viewer) {
  clearInterval($viewer.data('spinTimer'));
}
$(document).on('mousedown touchstart', '.js-spin-viewer', function(e) {
  var $viewer = $(this);
  var frames = getSpinFrames($viewer);
  if (!frames.length) return;

  e.preventDefault();

  stopSpinViewer($viewer);

  $viewer.addClass('is-dragging has-dragged');
  $viewer.removeClass('has-overlay');

  var point = e.pageX || e.originalEvent.touches[0].pageX;
  var startX = point;
  var index = Number($viewer.attr('data-spin-index') || 0);
  var $img = $viewer.find('img').first();
  var moved = false;

  function moveSpin(ev) {
    ev.preventDefault();

    var x = ev.pageX || ev.originalEvent.touches[0].pageX;
    var diff = x - startX;

    if (Math.abs(diff) > 8) {
      moved = true;

      if (diff > 0) {
        index = index - 1;
      } else {
        index = index + 1;
      }

      if (index < 0) index = frames.length - 1;
      if (index >= frames.length) index = 0;

      $img.attr('src', frames[index].url);
      $viewer.attr('data-spin-index', index);

      startX = x;
    }
  }

  function endSpin() {
    $(document).off('mousemove touchmove', moveSpin);
    $(document).off('mouseup touchend', endSpin);

    $viewer.removeClass('is-dragging');

    if (moved) {
      $viewer.data('blockClick', true);

      setTimeout(function() {
        $viewer.data('blockClick', false);
      }, 300);
    }

    /* Restart auto-spin only on the normal product page, never fullscreen */
    if (!$viewer.closest('#spin-fullscreen').length) {
      startSpinViewer($viewer);
    }
  }

  $(document).on('mousemove touchmove', moveSpin);
  $(document).on('mouseup touchend', endSpin);
});

$(document).on('click', '.js-spin-viewer', function(e) {
  var $viewer = $(this);

  if ($viewer.data('blockClick')) return;
  if ($viewer.closest('#spin-fullscreen').length) return;

  var frames = getSpinFrames($viewer);
  if (!frames.length) return;

  var currentIndex = Number($viewer.attr('data-spin-index') || 0);

  stopSpinViewer($viewer);

  var html =
    '<div id="spin-fullscreen">' +
      '<button type="button" class="spin-close" aria-label="Close 360 view">×</button>' +
      '<div class="spin-viewer js-spin-viewer spin-fullscreen-viewer has-overlay" data-spin-index="' + currentIndex + '" data-frames="' + encodeURIComponent(JSON.stringify(frames)) + '">' +
        '<div class="spin-start-overlay">' +
          '<div class="spin-start-logo"><svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 162.49 145.2"><defs><style>.st2{fill:#fff}.st3{fill:#f7032e}</style></defs><path d="M107.21 114.71v27.01c1.91-.36 3.8-.76 5.66-1.2 9.67-2.29 18.36-5.56 25.82-9.74 7.46-4.17 13.32-9.03 17.41-14.44 4.24-5.6 6.39-11.55 6.39-17.69V71.64c0 5.31-1.61 10.48-4.79 15.41-.49.77-1.02 1.52-1.59 2.28-4.09 5.41-9.95 10.27-17.41 14.44s-16.15 7.45-25.82 9.74c-1.87.44-3.76.84-5.66 1.2Z" class="st3"/><path d="M0 71.64c0 5.31 1.61 10.48 4.79 15.41 9.14-18.82 39.95-32.7 76.46-32.7s67.32 13.88 76.45 32.69c3.18-4.93 4.79-10.1 4.79-15.41 0-6.14-2.15-12.09-6.39-17.69-4.09-5.41-9.95-10.27-17.41-14.44s-16.15-7.45-25.82-9.74c-10.02-2.37-20.66-3.57-31.63-3.57s-21.61 1.2-31.63 3.57c-9.67 2.29-18.36 5.56-25.83 9.74-7.46 4.17-13.32 9.03-17.41 14.44-4.24 5.6-6.39 11.55-6.39 17.69Z" style="fill:#bc032e"/><path d="M0 71.64v27.01c0 6.13 2.15 12.08 6.39 17.69 4.09 5.41 9.95 10.27 17.41 14.44 5.71 3.19 12.13 5.86 19.17 7.96v6.46l10.42-3.85 27.86-11.4-21.88-14.53-16.4-10.9v7.21c-7.04-2.1-13.46-4.77-19.17-7.96-7.46-4.17-13.32-9.03-17.41-14.44-.57-.75-1.1-1.51-1.59-2.27C1.62 82.13.01 76.96.01 71.65Z" class="st3"/><circle cx="81.84" cy="55.88" r="55.88" style="fill:#252a66"/><path d="m62.65 47.2 2.92-19.85h3.51l-3.75 24.33h-5.7l-3.75-24.33h3.86l2.92 19.85ZM70.83 27.35h3.82v24.33h-3.82zM80.8 37.61h5.25v3.48H80.8v7.13h6.6v3.48H76.97V27.37H87.4v3.48h-6.6v6.78ZM98.38 38.72l-1.39 12.96h-5.25l-2.71-24.33h3.72l2.05 19.19 1.84-19.19h3.68l1.91 19.33 1.98-19.33h3.34l-2.71 24.33h-5.08l-1.39-12.96ZM68.09 64.46c0-1.21-.2-2.03-.6-2.45s-.93-.64-1.6-.64-1.2.2-1.6.6q-.6.6-.6 2.07v1.74h-4.02v-1.47c0-2.19.53-3.87 1.6-5.04s2.65-1.76 4.73-1.76 3.66.59 4.73 1.76 1.6 2.85 1.6 5.04v.7c0 2.88-.99 4.74-2.98 5.56 1.08.46 1.85 1.18 2.3 2.14.45.97.68 2.14.68 3.54v2.12c0 2.19-.54 3.87-1.6 5.04-1.07 1.17-2.65 1.76-4.73 1.76s-3.66-.59-4.73-1.76-1.6-2.85-1.6-5.04v-2.24h4.02v2.51q0 1.47.6 2.07c.4.4.93.6 1.6.6s1.2-.21 1.6-.62q.6-.615.6-2.43v-2.12q0-1.89-.66-2.67c-.44-.51-1.15-.77-2.12-.77h-1.43v-3.86h1.66c.8 0 1.42-.21 1.87-.62s.68-1.16.68-2.24v-1.51ZM74.54 64.54c0-2.29.53-4.04 1.58-5.24 1.06-1.2 2.69-1.8 4.91-1.8 2.09 0 3.66.59 4.73 1.76s1.6 2.85 1.6 5.04v.7h-4.02v-.97q0-1.47-.6-2.07c-.6-.6-.93-.6-1.6-.6-.75 0-1.33.23-1.74.7-.41.46-.62 1.34-.62 2.63v4.95c.75-1.6 2.06-2.4 3.94-2.4 1.57 0 2.75.53 3.54 1.58.79 1.06 1.18 2.59 1.18 4.6v4.95c0 2.19-.55 3.87-1.66 5.04s-2.7 1.76-4.79 1.76-3.68-.59-4.79-1.76-1.66-2.85-1.66-5.04zM81 71.11c-.67 0-1.2.2-1.6.6q-.6.6-.6 2.07v4.87c0 .98.2 1.66.6 2.05s.93.58 1.6.58 1.2-.19 1.6-.58.6-1.07.6-2.05v-4.87q0-1.47-.6-2.07c-.6-.6-.93-.6-1.6-.6M89.52 64.31c0-2.19.55-3.87 1.66-5.04s2.7-1.76 4.79-1.76 3.68.59 4.79 1.76 1.66 2.85 1.66 5.04v14.06c0 2.19-.55 3.87-1.66 5.04s-2.7 1.76-4.79 1.76-3.68-.59-4.79-1.76-1.66-2.85-1.66-5.04zm4.25 14.33q0 1.47.6 2.07c.4.4.93.6 1.6.6s1.2-.2 1.6-.6.6-1.09.6-2.07v-14.6q0-1.47-.6-2.07c-.6-.6-.93-.6-1.6-.6s-1.2.2-1.6.6q-.6.6-.6 2.07z" class="st2"/><path d="M108.21 63.63c-.73 0-1.38-.16-1.96-.48s-1.03-.75-1.36-1.31c-.33-.55-.5-1.19-.5-1.89s.17-1.36.5-1.91.78-.98 1.36-1.3c.57-.32 1.23-.48 1.96-.48s1.4.16 1.98.48 1.03.75 1.36 1.3.49 1.18.49 1.91-.16 1.35-.49 1.9-.78.99-1.36 1.3q-.87.48-1.98.48Zm0-1.42c.41 0 .78-.09 1.1-.28.32-.18.58-.45.76-.79s.28-.74.28-1.19-.09-.85-.28-1.19-.44-.6-.76-.78-.68-.28-1.09-.28-.77.09-1.09.28c-.32.18-.58.44-.77.78s-.28.73-.28 1.19.09.84.28 1.19c.19.34.44.61.77.79.32.18.68.28 1.08.28Z" style="stroke:#fff;stroke-miterlimit:10;stroke-width:.39px;fill:#fff"/></svg></div>' +
          '<div class="spin-start-text">Click & drag to rotate the 360° view</div>' +
        '</div>' +
        '<img draggable="false" src="' + frames[currentIndex].url + '" alt="360 product view">' +
      '</div>' +
    '</div>';

  $('body').append(html);
  $('html').addClass('spin-open');
});

$(document).on('click', '.spin-close, #spin-fullscreen', function(e) {
  if ($(e.target).closest('.spin-fullscreen-viewer').length) return;

  $('#spin-fullscreen').remove();
  $('html').removeClass('spin-open');

  setTimeout(function() {
    $('#product-images .js-spin-viewer').each(function() {
      startSpinViewer($(this));
    });
  }, 100);
});


// Helper function to handle cart response
function handleCartResponse(response, button, overselling) {

  if (
    response.status == 422 &&
    overselling == 'deny'
  ) {

    button.css('display', 'none');

    $('#fading-message')
      .html(
        '<span>You have all our remaining stock in your basket</span>' +
        '<a class="button" href="/cart">Go to basket</a>'
      )
      .addClass('show red');

    return;
  }


  /*
    Successful add.

    Both the standard and sticky add-to-basket
    buttons now behave in exactly the same way.
  */

  button.html('Add to basket');


  jQuery.get(
    '/cart.js',

    function(data) {


      $('.js-basket-contents-number')
      .css('display', data.item_count > 0 ? 'flex' : 'none')
      .text(data.item_count);

      $('.mob-icon.basket .basket-contents')
        .css('display', data.item_count > 0 ? 'flex' : 'none')
        .text(data.item_count);
      

      document.dispatchEvent(
        new CustomEvent(
          'cm:cart-changed',
          {
            detail: {
              cart: data
            }
          }
        )
      );

    },

    'json'
  );


  return response.json();
}

// no overselling when inventory policy == deny
(function(){
  if (window.QtyCap) return;

  function getWrap(el){
    return el.closest && el.closest('.no_overselling, [data-max]');
  }
  function getMaxFor(el){
    var w = getWrap(el);
    if (!w) return null;
    var m = parseInt(w.getAttribute('data-max') || '', 10);
    return isNaN(m) ? null : Math.max(1, m);
  }
  function clamp(input){
    var min = parseInt(input.min || '1', 10);
    var val = parseInt(input.value || String(min), 10);
    if (isNaN(val) || val < min) val = min;

    var max = getMaxFor(input);
    if (max != null) {
      if (val > max) val = max;
      input.setAttribute('max', String(max));
    } else {
      input.removeAttribute('max');
    }
    if (String(input.value) !== String(val)) input.value = String(val);
    return val;
  }

  document.addEventListener('click', function(e){
    var plus = e.target.closest && e.target.closest('.number-input .plus');
    if (!plus) return;
    var input = plus.closest('.number-input')?.querySelector('input[type="number"]');
    if (!input) return;

    var max = getMaxFor(plus);
    var cur = parseInt(input.value || input.min || '1', 10);
    if (max != null && !isNaN(cur) && cur >= max) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return; 
    }
    setTimeout(function(){ clamp(input); }, 0);
  }, true);

  document.addEventListener('input', function(e){
    if (e.target.matches && e.target.matches('.number-input input[type="number"]')) clamp(e.target);
  });
  document.addEventListener('change', function(e){
    if (e.target.matches && e.target.matches('.number-input input[type="number"]')) clamp(e.target);
  }, true);

  function syncAll(){
    document.querySelectorAll('.number-input input[type="number"]').forEach(clamp);
  }
  syncAll();
  new MutationObserver(syncAll).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['data-max','class']
  });

  window.QtyCap = {
    applyFromExpanded: function(variantId){
      try {
        var vmap = window.expanded_variants;
        var v = vmap && (vmap[String(variantId)] || vmap[Number(variantId)]);
        var deny = v && (v.stock_policy === 'deny' || String(v.no_overselling) === 'true' || v.inventory_policy === 'deny');
        var max = v && (parseInt(v.stock_level ?? v.inventory_quantity, 10));
        var wrap = document.getElementById('add-to-basket');

        if (wrap) {
          if (deny && !isNaN(max) && max > 0) {
            wrap.classList.add('no_overselling');
            wrap.setAttribute('data-max', String(max));
          } else {
            wrap.classList.remove('no_overselling');
            wrap.removeAttribute('data-max');
          }
        }
        syncAll();
      } catch(_){}
    }
  };
})();

// Alter Shopify Form App styling ---- FORCE HACK
function injectShopifyFormsShadowCss() {
  var el = document.querySelector('shopify-forms-embed');
  if (!el || !el.shadowRoot) return;
  if (el.shadowRoot.getElementById('custom-forms-css')) return;
  var css = `
    ._formContainer_1q1d2_30 {
      max-width:1000px!important;
    }
  `;
  var style = document.createElement('style');
  style.id = 'custom-forms-css';
  style.textContent = css;
  el.shadowRoot.appendChild(style);
}
window.addEventListener('load', function () {
  injectShopifyFormsShadowCss();
  setTimeout(injectShopifyFormsShadowCss, 300);
});

// Husk desktop expanding search
$(document).ready(function () {
  if (!$('#expanding-desktop-search-form').length) return;

  var huskPreloader = "//www.huskcups.co.uk/cdn/shop/t/2/assets/preloader.gif?v=77008736554601496081763466763";

  function huskLoadSuggestions(query) {
    return $.ajax({
      url: '/search/suggest',
      data: {
        section_id: 'predictive-search',
        q: query,
        resources: {
          type: 'collection,product,article',
          fields: 'variants.sku,title,tag,variants.title,variants.barcode,product_type,body'
        }
      },
      dataType: 'html'
    }).done(function (data) {
      $('#expanding-desktop-results-box').html(data);
    });
  }

  function huskShowSuggestions() {
    var query = $('#expanding-desktop-search-input').val() || '';

    $('#expanding-desktop-results-box').empty();

    if (query.replace(/ /g, '').length > 0) {
      query = query.replace(':', ' ');
      $('#expanding-desktop-search-input').val(query);
      $('#expanding-desktop-search-form').attr('action', '/search');
      $('#expanding-desktop-search-form').addClass('results-open');

      $('#expanding-desktop-results-box')
        .html('<div style="padding:20px;display:flex;justify-content:center;align-items:center;background-color:#fff;"><img src="' + huskPreloader + '" alt=""></div>')
        .css('display', 'block');

      clearTimeout(window.huskSearchTimer);
      window.huskSearchTimer = setTimeout(function () {
        huskLoadSuggestions(query);
      }, 250);
    } else {
      $('#expanding-desktop-search-form').attr('action', '/search');
      $('#expanding-desktop-search-form').removeClass('results-open');
      $('#expanding-desktop-results-box').css('display', 'none');
    }
  }

  function openHuskSearch() {
    $('#expanding-desktop-search-form').addClass('visible');
    $('.header-content.desktop.hc, .header-content.desktop.mh').addClass('search-active');

    setTimeout(function () {
      $('#expanding-desktop-search-input').focus();
    }, 120);
  }

  function closeExpandingSearch() {
    $('#expanding-desktop-search-form').removeClass('visible results-open');
    $('#expanding-desktop-results-box').hide();
    $('.header-content.desktop.hc, .header-content.desktop.mh').removeClass('search-active');
  }

  $('.header-content.desktop.hc .expanding-search-button, .header-content.desktop.mh .expanding-search-button').on('click', function (e) {
    if (window.innerWidth < 1000) return;

    var isVisible = $('#expanding-desktop-search-form').hasClass('visible');
    var hasText = $.trim($('#expanding-desktop-search-input').val()).length > 0;

    if (!isVisible) {
      e.preventDefault();
      e.stopPropagation();
      openHuskSearch();
      hideMenu();
      hideFilterMenu();
      return;
    }

    if (isVisible && !hasText) {
      e.preventDefault();
      e.stopPropagation();
      closeExpandingSearch();
    }
  });

  $('#expanding-desktop-search-input').on('input', function () {
    huskShowSuggestions();
  });

  $('#expanding-desktop-search-input').on('focus', function () {
    if ($('#expanding-desktop-search-form').hasClass('visible')) {
      huskShowSuggestions();
    }
  });

  $('#expanding-desktop-search-input').on('keyup', function (e) {
    if (e.which === 27) {
      closeExpandingSearch();
    }
  });

  $(document).on('click', function (event) {
    if (window.innerWidth < 1000) return;

    if (!$(event.target).closest('.header-content.desktop.hc .expanding-search-expand').length) {
      closeExpandingSearch();
    }
  });
});

/*
 * Checkout promotions engine
 * Reads #cm-checkout-promotions-data rendered by snippets/checkout-promotions-data.liquid.
 */
(function () {
  'use strict';

  if (window.CMCheckoutPromotions) return;

  var OFFER_PROPERTY_KEYS = [
    '_offer_id',
    '_offer_name',
    '_offer_mode',
    '_offer_discount_percent',
    '_offer_discount_qty',
    '_offer_reward'
  ];

  var state = {
    data: null,
    running: false,
    rerun: false,
    pickerOverrides: {},
    pickerDrafts: {},
    pickerChosenVariants: {},
    pickerExpanded: {},
    lastActiveOfferIds: [],
    activeOffers: [],
    unsupportedNativeDiscounts: false,
    lastCart: null,
    utmIds: []
  };

  function rootUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
  }

  function parseData() {
    var node = document.getElementById('cm-checkout-promotions-data');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.error('Promotion data could not be parsed:', error);
      return null;
    }
  }

  function promotionSuccessTickHtml() {
    var template = document.getElementById('cm-promotion-success-tick-template');
    return template ? template.innerHTML : '';
  }

  function asArray(value) {
    if (Array.isArray(value)) return value;
    if (value === null || typeof value === 'undefined' || value === '') return [];
    return String(value).split(',');
  }

  function cleanStrings(values, upperCase) {
    return asArray(values)
      .map(function (value) { return String(value || '').trim(); })
      .filter(Boolean)
      .map(function (value) { return upperCase ? value.toUpperCase() : value.toLowerCase(); });
  }

  function unique(values) {
    return values.filter(function (value, index, array) {
      return array.indexOf(value) === index;
    });
  }

  function integer(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function number(value, fallback) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function propertiesOf(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isRewardLine(item) {
    var props = propertiesOf(item);
    return String(props._offer_reward || '').toLowerCase() === 'true';
  }

  function isPromotionLine(item) {
    return Boolean(propertiesOf(item)._offer_id);
  }

  function baseItems(cart) {
    return (cart.items || []).filter(function (item) {
      return !isRewardLine(item) && !propertiesOf(item)._required_extra;
    });
  }

  function normaliseId(value) {
    return String(value || '');
  }

  function getCurrentVariantId() {
    var input = document.getElementById('variant-id');
    return input && input.value ? normaliseId(input.value) : '';
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname) || document.body.classList.contains('template-cart');
  }

  function metadataForVariant(variantId) {
    var data = state.data || {};
    var metadata = data.cartProducts && data.cartProducts[normaliseId(variantId)];
    if (metadata) return metadata;

    var current = data.currentProduct;
    if (current && Array.isArray(current.variantIds) && current.variantIds.map(normaliseId).indexOf(normaliseId(variantId)) !== -1) {
      return current;
    }

    return null;
  }

  function fetchCart() {
    return fetch(rootUrl('cart.js'), {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not load the cart');
      return response.json();
    });
  }

  function changeLine(key, quantity, properties) {
    var body = { id: key, quantity: quantity };
    if (properties) body.properties = properties;

    return fetch(rootUrl('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) return response.text().then(function (text) { throw new Error(text || 'Cart line update failed'); });
      return response.json();
    });
  }

  function addItems(items) {
    if (!items.length) return Promise.resolve(null);

    return fetch(rootUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) return response.text().then(function (text) { throw new Error(text || 'Promotion item could not be added'); });
      return response.json();
    });
  }

  function updateCartAttributes(attributes) {
    return fetch(rootUrl('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('Promotion cart attributes could not be updated');
      return response.json();
    });
  }

  function stableObject(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
    var result = {};
    Object.keys(value).sort().forEach(function (key) {
      result[key] = value[key];
    });
    return result;
  }

  function propertiesEqual(a, b) {
    return JSON.stringify(stableObject(a || {})) === JSON.stringify(stableObject(b || {}));
  }

  function stripOfferProperties(properties) {
    var output = {};
    Object.keys(properties || {}).forEach(function (key) {
      if (OFFER_PROPERTY_KEYS.indexOf(key) === -1) output[key] = properties[key];
    });
    return output;
  }

  function offerProperties(baseProperties, offer, discountQuantity, rewardLine) {
    var props = stripOfferProperties(baseProperties || {});
    props._offer_id = offer.id;
    props._offer_name = offer.displayName;
    props._offer_mode = offer.rewardMode;
    props._offer_discount_percent = String(clamp(number(offer.discountPercent, 0), 0, 100));
    props._offer_discount_qty = String(Math.max(0, integer(discountQuantity, 0)));
    if (rewardLine) props._offer_reward = 'true';
    return props;
  }

  function captureUtmId(cart) {
    var params = new URLSearchParams(window.location.search);
    var current = String(params.get('utm_id') || '').trim().toLowerCase();
    var stored = [];

    try {
      stored = cleanStrings(JSON.parse(sessionStorage.getItem('cmPromotionUtmIds') || '[]'), false);
    } catch (error) {
      stored = [];
    }

    stored = stored.concat(cleanStrings(state.data && state.data.storedUtmIds, false));
    stored = stored.concat(cleanStrings(cart && cart.attributes && cart.attributes._promotion_utm_ids, false));
    if (current) stored.push(current);
    stored = unique(stored);

    try {
      sessionStorage.setItem('cmPromotionUtmIds', JSON.stringify(stored));
    } catch (error) {
      // Storage can be unavailable in private browsing; the cart attribute still works.
    }

    var currentCartValue = cleanStrings(cart && cart.attributes && cart.attributes._promotion_utm_ids, false).join(',');
    var nextCartValue = stored.join(',');

    if (nextCartValue && nextCartValue !== currentCartValue) {
      return updateCartAttributes({ _promotion_utm_ids: nextCartValue }).then(function () { return stored; });
    }

    return Promise.resolve(stored);
  }

  function promoCodes(cart) {
    var input = document.getElementById('promo_code_input');
    var values = [];
    if (input) values = values.concat(cleanStrings(input.value, true));
    values = values.concat(cleanStrings(state.data && state.data.storedPromoCodes, true));
    values = values.concat(cleanStrings(cart && cart.attributes && cart.attributes._discount_code, true));
    return unique(values);
  }

  function customerTags() {
    return cleanStrings(state.data && state.data.customerTags, false);
  }

  function offerInDateWindow(offer) {
    var now = Date.now();
    var start = offer.startAt ? Date.parse(offer.startAt) : NaN;
    var end = offer.endAt ? Date.parse(offer.endAt) : NaN;
    if (!isNaN(start) && now < start) return false;
    if (!isNaN(end) && now > end) return false;
    return true;
  }

  function quantityForVariant(items, variantId) {
    return items.reduce(function (total, item) {
      return normaliseId(item.variant_id) === normaliseId(variantId) ? total + integer(item.quantity, 0) : total;
    }, 0);
  }

  function itemMatchesProductTrigger(item, type, expected) {
    var metadata = metadataForVariant(item.variant_id);
    if (!metadata) return false;

    if (type === 'vendor') {
      return String(metadata.vendor || '').toLowerCase() === String(expected || '').toLowerCase();
    }

    if (type === 'collection') {
      return cleanStrings(metadata.collections, false).indexOf(String(expected || '').toLowerCase()) !== -1;
    }

    if (type === 'product_tag') {
      return cleanStrings(metadata.tags, false).indexOf(String(expected || '').toLowerCase()) !== -1;
    }

    return false;
  }

  function subtotalForEvaluation(cart) {
    if (isCartPage() && state.data && number(state.data.cartSubtotal, -1) >= 0) {
      return number(state.data.cartSubtotal, 0);
    }

    // Shopify's cart total still contains the full price of managed reward
    // lines. Remove those lines so a free/discounted reward cannot qualify its
    // own promotion or make a threshold promotion oscillate on and off.
    var managedRewardTotal = (cart.items || []).reduce(function (total, item) {
      return isRewardLine(item) ? total + number(item.final_line_price, 0) : total;
    }, 0);

    return Math.max(0, number(cart.total_price, 0) - managedRewardTotal);
  }

  function offerQualifies(offer, cart, utmIds) {
    if (!offer || !offer.id || !offerInDateWindow(offer)) return false;
    if (['auto_add', 'auto_discount_existing', 'picker', 'whole_basket'].indexOf(offer.rewardMode) === -1) return false;
    if (offer.rewardMode === 'auto_discount_existing') {
      var hasEligibleVariants =
        Array.isArray(offer.eligibleVariantIds) &&
        offer.eligibleVariantIds.length > 0;

      var hasLegacyRewardVariants =
        Array.isArray(offer.rewardVariants) &&
        offer.rewardVariants.length > 0;

      if (!hasEligibleVariants && !hasLegacyRewardVariants) return false;
    } else if (offer.rewardMode !== 'whole_basket') {
      if (!Array.isArray(offer.rewardVariants) || !offer.rewardVariants.length) return false;
    }

    var items = baseItems(cart);
    var requiredIds = (offer.requiredVariantIds || []).map(normaliseId);
    var minimumQuantityTriggers = [];
    var codes = promoCodes(cart);
    var tags = customerTags();
    var triggers = Array.isArray(offer.triggers) ? offer.triggers : [];

    for (var i = 0; i < triggers.length; i += 1) {
      var trigger = triggers[i] || {};
      var type = String(trigger.type || '').trim().toLowerCase();
      var value = trigger.value;

      if (!type) continue;

      if (type === 'promo_code') {
        if (codes.indexOf(String(value || '').trim().toUpperCase()) === -1) return false;
      } else if (type === 'utm_id') {
        if (utmIds.indexOf(String(value || '').trim().toLowerCase()) === -1) return false;
      } else if (type === 'min_subtotal') {
        if (subtotalForEvaluation(cart) < Math.round(number(value, 0) * 100)) return false;
      } else if (type === 'min_qty') {
        minimumQuantityTriggers.push(Math.max(1, integer(value, 1)));
      } else if (type === 'customer_tag') {
        if (tags.indexOf(String(value || '').trim().toLowerCase()) === -1) return false;
      } else if (type === 'vendor' || type === 'collection' || type === 'product_tag') {
        if (!items.some(function (item) { return itemMatchesProductTrigger(item, type, value); })) return false;
      } else {
        console.warn('Unknown promotion trigger type:', type, 'in', offer.id);
        return false;
      }
    }

    var minimumRequired = minimumQuantityTriggers.length ? Math.max.apply(Math, minimumQuantityTriggers) : 1;

    if (requiredIds.length) {
      // Each required variant must be present at its own minimum quantity
      // (requiredQuantities, default 1), or the min_qty trigger if higher.
      var requiredQuantities = offer.requiredQuantities || {};

      for (var requiredIndex = 0; requiredIndex < requiredIds.length; requiredIndex += 1) {
        var requiredId = requiredIds[requiredIndex];
        var neededQuantity = Math.max(
          integer(requiredQuantities[requiredId], 1),
          minimumRequired
        );

        if (quantityForVariant(items, requiredId) < neededQuantity) return false;
      }

    } else if (minimumQuantityTriggers.length) {
      var totalQuantity = items.reduce(function (total, item) { return total + integer(item.quantity, 0); }, 0);
      if (totalQuantity < minimumRequired) return false;
    }

    return true;
  }

  function activeOffers(cart, utmIds) {
    return (state.data.offers || []).filter(function (offer) {
      return offerQualifies(offer, cart, utmIds);
    });
  }

  function promotionFamilyHandle(offer) {

    return String(offer && offer.id || '')
      .trim()
      .toLowerCase()
      .replace(/_\d+$/, '');
  }


  function promotionRewardSignature(offer) {

    return (offer.rewardVariants || [])
      .map(function (variant) {
        return normaliseId(variant.id);
      })
      .sort()
      .join(',');
  }


  function isSingleRewardFamilyOffer(offer) {
    if (!offer) return false;

    if (offer.maxDiscountedQtyExplicit !== true) return false;
    if (integer(offer.maxDiscountedQty, 0) !== 1) return false;

    if (
      offer.rewardMode !== 'picker' &&
      offer.rewardMode !== 'auto_add'
    ) {
      return false;
    }

    return Array.isArray(offer.rewardVariants) &&
      offer.rewardVariants.length > 0;
  }


  function dedupeSingleRewardFamilies(active, cart) {
    var groups = {};


    active.forEach(function (offer) {
      if (!isSingleRewardFamilyOffer(offer)) return;

      var key =
        promotionFamilyHandle(offer) +
        '|' +
        promotionRewardSignature(offer);

      if (!groups[key]) groups[key] = [];
      groups[key].push(offer);
    });


    var winningOfferIds = {};

    Object.keys(groups).forEach(function (key) {
      var offers = groups[key];

      if (offers.length === 1) {
        winningOfferIds[String(offers[0].id)] = true;
        return;
      }

      var winner = null;

      (cart.items || []).some(function (item) {
        if (!isRewardLine(item)) return false;

        var ownerId = String(propertiesOf(item)._offer_id || '');

        winner = offers.find(function (offer) {
          return String(offer.id) === ownerId;
        }) || null;

        return Boolean(winner);
      });

      if (!winner) {
        winner = offers.slice().sort(function (a, b) {
          function rank(offer) {
            var id = String(offer.id || '');
            var match = id.match(/_(\d+)$/);

            return match ? integer(match[1], 999999) : 1;
          }

          return rank(a) - rank(b);
        })[0];
      }


      if (winner) {
        winningOfferIds[String(winner.id)] = true;
      }
    });


    return active.filter(function (offer) {
      if (!isSingleRewardFamilyOffer(offer)) return true;

      var key =
        promotionFamilyHandle(offer) +
        '|' +
        promotionRewardSignature(offer);

      return winningOfferIds[String(offer.id)] === true;
    });
  }

  function rewardVariantCapacity(rewardVariant) {
    if (!rewardVariant) return 0;
    if (String(rewardVariant.inventoryPolicy || '').toLowerCase() === 'deny') {
      return Math.max(0, integer(rewardVariant.inventoryQuantity, 0));
    }
    return Number.MAX_SAFE_INTEGER;
  }

  function distributeAutoAdd(offer) {
    var variants = (offer.rewardVariants || []).filter(function (variant) {
      return variant && (variant.available || String(variant.inventoryPolicy || '').toLowerCase() === 'continue') && rewardVariantCapacity(variant) > 0;
    });
    var maximum = Math.max(1, integer(offer.maxDiscountedQty, 1));
    var result = {};
    var remaining = maximum;
    var safety = 0;

    variants.forEach(function (variant) { result[normaliseId(variant.id)] = 0; });

    while (remaining > 0 && variants.length && safety < maximum * Math.max(variants.length, 1) + 20) {
      var addedThisPass = false;
      for (var i = 0; i < variants.length && remaining > 0; i += 1) {
        var id = normaliseId(variants[i].id);
        if (result[id] < rewardVariantCapacity(variants[i])) {
          result[id] += 1;
          remaining -= 1;
          addedThisPass = true;
        }
      }
      if (!addedThisPass) break;
      safety += 1;
    }

    return result;
  }

  function existingPickerSelection(offer, cart) {
    var result = {};
    (offer.rewardVariants || []).forEach(function (variant) { result[normaliseId(variant.id)] = 0; });

    (cart.items || []).forEach(function (item) {
      var props = propertiesOf(item);
      if (String(props._offer_id || '') === String(offer.id) && isRewardLine(item)) {
        var id = normaliseId(item.variant_id);
        if (Object.prototype.hasOwnProperty.call(result, id)) result[id] += integer(item.quantity, 0);
      }
    });

    return result;
  }

  function clampPickerSelection(offer, selection) {
    var result = {};
    var remaining = Math.max(1, integer(offer.maxDiscountedQty, 1));

    (offer.rewardVariants || []).forEach(function (variant) {
      var id = normaliseId(variant.id);
      var requested = Math.max(0, integer(selection && selection[id], 0));
      var allowed = Math.min(requested, 1, rewardVariantCapacity(variant), remaining);
      result[id] = allowed;
      remaining -= allowed;
    });

    return result;
  }

  function rewardVariantById(offer, variantId) {
    return (offer.rewardVariants || []).find(function (variant) {
      return normaliseId(variant.id) === normaliseId(variantId);
    });
  }

  function buildRewardLine(offer, rewardVariant, quantity) {
    var props = offerProperties({
      _stocklevel: String(integer(rewardVariant.inventoryQuantity, 0)),
      _stockpolicy: String(rewardVariant.inventoryPolicy || 'continue'),
      _condition: String(rewardVariant.condition || 'A1'),
      _dealer_type: String(rewardVariant.dealerType || 'Standard'),
      _qbreaks: (function (q) { return (q != null && typeof q !== 'string') ? JSON.stringify(q) : (q || '[]'); })(rewardVariant.qbreaks)
    }, offer, quantity, true);

    return {
      id: integer(rewardVariant.id, 0),
      quantity: quantity,
      properties: props
    };
  }

  function desiredRewardLines(active, cart) {
    var desired = {};

    active.forEach(function (offer) {
      var selection = null;

      if (offer.rewardMode === 'auto_add') {
        selection = distributeAutoAdd(offer);
      } else if (offer.rewardMode === 'picker') {
        selection = state.pickerOverrides[offer.id] || existingPickerSelection(offer, cart);
        selection = clampPickerSelection(offer, selection);
      }

      if (!selection) return;

      Object.keys(selection).forEach(function (variantId) {
        var quantity = integer(selection[variantId], 0);
        if (quantity < 1) return;

        desired[String(offer.id) + '|' + variantId] = {
          offer: offer,
          rewardVariant: rewardVariantById(offer, variantId),
          quantity: quantity
        };
      });
    });

    return desired;
  }

  async function reconcileRewardLines(active, cart) {
    var desired = desiredRewardLines(active, cart);
    var existing = {};
    var changed = false;

    (cart.items || []).forEach(function (item) {
      if (!isRewardLine(item)) return;
      var props = propertiesOf(item);
      var identity = String(props._offer_id || '') + '|' + normaliseId(item.variant_id);
      if (!existing[identity]) existing[identity] = [];
      existing[identity].push(item);
    });

    var identities = unique(Object.keys(existing).concat(Object.keys(desired)));
    var additions = [];

    for (var i = 0; i < identities.length; i += 1) {
      var identity = identities[i];
      var wanted = desired[identity];
      var lines = existing[identity] || [];

      if (!wanted) {
        for (var removeIndex = 0; removeIndex < lines.length; removeIndex += 1) {
          await changeLine(lines[removeIndex].key, 0);
          changed = true;
        }
        continue;
      }

      if (!wanted.rewardVariant) continue;

      var expectedProps = buildRewardLine(wanted.offer, wanted.rewardVariant, wanted.quantity).properties;

      if (lines.length) {
        var primary = lines[0];
        if (integer(primary.quantity, 0) !== wanted.quantity || !propertiesEqual(propertiesOf(primary), expectedProps)) {
          await changeLine(primary.key, wanted.quantity, expectedProps);
          changed = true;
        }

        for (var duplicateIndex = 1; duplicateIndex < lines.length; duplicateIndex += 1) {
          await changeLine(lines[duplicateIndex].key, 0);
          changed = true;
        }
      } else {
        additions.push(buildRewardLine(wanted.offer, wanted.rewardVariant, wanted.quantity));
      }
    }

    if (additions.length) {
      await addItems(additions);
      changed = true;
    }

    return changed;
  }

  function existingDiscountAssignments(active, cart) {
    var assignments = {};
    var lines = baseItems(cart);
    var offers = active
      .filter(function (offer) {
        return offer.rewardMode === 'auto_discount_existing' || offer.rewardMode === 'whole_basket';
      })
      .sort(function (a, b) { return number(b.discountPercent, 0) - number(a.discountPercent, 0); });

    offers.forEach(function (offer) {
      var configuredMaximum = integer(offer.maxDiscountedQty, 0);

      var remaining = configuredMaximum > 0
        ? configuredMaximum
        : Number.MAX_SAFE_INTEGER;
      var eligibleIds;

      if (offer.rewardMode === 'whole_basket') {
        // Every line in the basket is eligible.
        eligibleIds = unique(lines.map(function (line) { return normaliseId(line.variant_id); }));
      } else {
        eligibleIds = (offer.eligibleVariantIds || []).map(normaliseId);

        // Backwards compatibility with promotions configured before
        // auto_discount_existing used the Eligible variants field correctly.
        if (!eligibleIds.length) {
          eligibleIds = (offer.rewardVariants || []).map(function (variant) {
            return normaliseId(variant.id);
          });
        }
      }

      for (var eligibleIndex = 0; eligibleIndex < eligibleIds.length && remaining > 0; eligibleIndex += 1) {
        for (var lineIndex = 0; lineIndex < lines.length && remaining > 0; lineIndex += 1) {
          var line = lines[lineIndex];

          if (assignments[line.key]) continue;
          if (normaliseId(line.variant_id) !== eligibleIds[eligibleIndex]) continue;

          var discountQuantity = Math.min(integer(line.quantity, 0), remaining);
          if (discountQuantity < 1) continue;

          assignments[line.key] = {
            offer: offer,
            quantity: discountQuantity
          };
          remaining -= discountQuantity;
        }
      }
    });

    return assignments;
  }

  async function reconcileExistingDiscounts(active, cart) {
    var assignments = existingDiscountAssignments(active, cart);
    var changed = false;
    var lines = baseItems(cart);

    for (var i = 0; i < lines.length; i += 1) {
      var line = lines[i];
      var props = propertiesOf(line);
      var assignment = assignments[line.key];
      var nextProps = assignment
        ? offerProperties(props, assignment.offer, assignment.quantity, false)
        : stripOfferProperties(props);

      if (!propertiesEqual(props, nextProps)) {
        await changeLine(line.key, integer(line.quantity, 0), nextProps);
        changed = true;
      }
    }

    return changed;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function groupRewardVariants(offer) {
    var groups = [];
    var byProduct = {};

    (offer.rewardVariants || []).forEach(function (variant) {
      var productKey = normaliseId(variant.productId || variant.productTitle || variant.id);
      if (!byProduct[productKey]) {
        byProduct[productKey] = {
          productId: productKey,
          productTitle: variant.productTitle || '',
          image: variant.image || '',
          variants: []
        };
        groups.push(byProduct[productKey]);
      }
      byProduct[productKey].variants.push(variant);
      if (!byProduct[productKey].image && variant.image) byProduct[productKey].image = variant.image;
    });

    return groups;
  }

  function availableGroupVariants(group) {
    return (group.variants || []).filter(function (variant) {
      return rewardVariantCapacity(variant) > 0 &&
        (variant.available || String(variant.inventoryPolicy || '').toLowerCase() === 'continue');
    });
  }

  function selectedVariantForGroup(group, selection) {
    return (group.variants || []).find(function (variant) {
      return integer(selection[normaliseId(variant.id)], 0) > 0;
    }) || null;
  }

  function selectedPickerTotal(selection) {
    return Object.keys(selection || {}).reduce(function (total, variantId) {
      return total + (integer(selection[variantId], 0) > 0 ? 1 : 0);
    }, 0);
  }

  function selectionIsSame(a, b) {
    var ids = unique(Object.keys(a || {}).concat(Object.keys(b || {})));
    return ids.every(function (id) {
      return integer(a && a[id], 0) === integer(b && b[id], 0);
    });
  }

  function capitaliseFirst(value) {
    var text = String(value || '').trim();
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : '';
  }

  function promotionEyebrow(offer) {
    var percent = clamp(number(offer && offer.discountPercent, 0), 0, 100);
    if (percent >= 100) return 'Free reward';
    if (percent > 0) return String(percent) + '% off reward';
    return 'Promotional reward';
  }

  function promotionTitle(offer) {
    var title = String((offer && offer.displayName) || '').trim();
    var percent = clamp(number(offer && offer.discountPercent, 0), 0, 100);

    if (percent > 0) {
      title = title.replace(/^\s*\d+(?:\.\d+)?%\s*off(?:\s+with)?\s*/i, '');
    }

    if (!title) {
      return percent >= 100 ? 'Your free reward' : 'Promotion available';
    }

    return capitaliseFirst(title);
  }

  function displayRewardVariantTitle(title) {
    var raw = String(title || '').trim();
    if (!raw || raw.toLowerCase() === 'default title') return '';

    var conditionNames = {
      A1: '',
      A2: 'Like new',
      A3: 'Ex demo',
      A4: 'Second hand',
      A5: 'Imperfect',
      C1: 'Clearance',
      DIS: 'On display',
      SO: 'Special offer'
    };

    return raw
      .split(/\s*\/\s*/)
      .map(function (part) {
        var trimmed = String(part || '').trim();
        var upper = trimmed.toUpperCase();
        return Object.prototype.hasOwnProperty.call(conditionNames, upper)
          ? conditionNames[upper]
          : trimmed;
      })
      .filter(Boolean)
      .join(' / ');
  }

  function pickerSelectionSummary(offer, selection) {
    var labels = [];

    (offer.rewardVariants || []).forEach(function (variant) {
      var id = normaliseId(variant.id);
      if (integer(selection && selection[id], 0) < 1) return;

      var label = variant.productTitle || '';
      var option = displayRewardVariantTitle(variant.title);
      if (option) label += ' - ' + option;
      if (label) labels.push(label);
    });

    if (!labels.length) return 'Your promotional reward';
    if (labels.length === 1) return labels[0];
    if (labels.length === 2) return labels.join(' + ');
    return labels.slice(0, 2).join(', ') + ' +' + (labels.length - 2) + ' more';
  }

  function pickerIsComplete(offer, cart) {
    var existing = clampPickerSelection(offer, existingPickerSelection(offer, cart));
    return selectedPickerTotal(existing) > 0;
  }

  function pickerDraftSelection(offer, cart) {
    if (Object.prototype.hasOwnProperty.call(state.pickerDrafts, offer.id)) {
      return clampPickerSelection(offer, state.pickerDrafts[offer.id]);
    }
    return clampPickerSelection(offer, existingPickerSelection(offer, cart));
  }

  function chosenVariantForGroup(offer, group, selection) {
    var selectedVariant = selectedVariantForGroup(group, selection);
    if (selectedVariant) return selectedVariant;

    var chosenByOffer = state.pickerChosenVariants[offer.id] || {};
    var chosenId = normaliseId(chosenByOffer[group.productId]);
    var available = availableGroupVariants(group);
    var storedVariant = available.find(function (variant) {
      return normaliseId(variant.id) === chosenId;
    });

    return storedVariant || available[0] || group.variants[0] || null;
  }

  function rewardPriceHtml(offer, variant) {
    if (!variant) return '';

    var percent = clamp(number(offer.discountPercent, 0), 0, 100);
    var regular = escapeHtml(variant.priceDisplay || '');
    var promotional = percent >= 100
      ? 'Free'
      : escapeHtml(variant.promotionPriceDisplay || variant.priceDisplay || '');
    var mainPrice = '';
    var extraPrice = '';

    if (percent > 0) {
      mainPrice =
        '<span class="checkout-promotion-choice-regular-price">' + regular + '</span>' +
        '<span class="checkout-promotion-choice-promo-price">' + promotional + '</span>';
    } else {
      mainPrice = '<span class="checkout-promotion-choice-promo-price">' + regular + '</span>';
    }

    if (variant.showExVat) {
      var exValue = percent > 0
        ? (variant.promotionExVatDisplay || variant.exVatDisplay || '')
        : (variant.exVatDisplay || '');
      if (exValue) {
        extraPrice = '<span><em>' + escapeHtml(exValue) + '</em> ex. VAT</span>';
      }
    }

    if (percent > 0 && percent < 100) {
      extraPrice += '<span class="checkout-promotion-saving-label">' +
        escapeHtml(String(percent)) + '% off with this promotion</span>';
    } else if (percent >= 100) {
      extraPrice += '<span class="checkout-promotion-saving-label">Free with this promotion</span>';
    }

    return '<div class="product-card-price checkout-promotion-card-price">' +
      mainPrice +
    '</div>' +
    '<div class="extra-prices checkout-promotion-card-extra">' + extraPrice + '</div>';
  }

  function pickerButtonState(offer, selection, cart) {
    var existing = clampPickerSelection(offer, existingPickerSelection(offer, cart));
    var selectedTotal = selectedPickerTotal(selection);
    var existingTotal = selectedPickerTotal(existing);
    var maximum = Math.max(1, integer(offer.maxDiscountedQty, 1));
    var unchanged = selectionIsSame(selection, existing);
    var label = maximum === 1 ? 'Add selected reward' : 'Add selected rewards';
    var disabled = false;

    if (unchanged && existingTotal > 0) {
      label = 'No changes';
      disabled = true;
    } else if (selectedTotal < 1 && existingTotal > 0) {
      label = maximum === 1 ? 'Remove reward' : 'Remove rewards';
    } else if (selectedTotal < 1) {
      label = maximum === 1 ? 'Select a reward' : 'Select rewards';
      disabled = true;
    }

    return {
      label: label,
      disabled: disabled,
      selectedTotal: selectedTotal,
      maximum: maximum
    };
  }

  function ensurePickerPlacement() {
    var container = document.getElementById('checkout-promotion-centre');
    var destination = document.getElementById('checkout-promotion-destination');

    if (container && destination && container.parentNode !== destination) {
      destination.appendChild(container);
    }

    return container;
  }

  function renderPickerReference(pickerOffers, cart) {
    var existing = document.getElementById('checkout-promotion-jump');

    if (!pickerOffers.length) {
      if (existing) existing.remove();
      return;
    }

    var slot = document.getElementById('checkout-promotion-jump-slot');
    var checkoutButton = document.getElementById('checkout-main');

    if (!slot && (!checkoutButton || !checkoutButton.parentNode)) return;

    var reference = existing || document.createElement('div');
    reference.id = 'checkout-promotion-jump';

    var incompleteOffers = pickerOffers.filter(function (offer) {
      return !pickerIsComplete(offer, cart);
    });
    var complete = incompleteOffers.length === 0;

    if (complete) {
      if (existing) existing.remove();
      return;
    }

    var plural = pickerOffers.length > 1;
    var targetOffer = incompleteOffers[0];

    reference.className = 'checkout-promotion-jump' + (complete ? ' is-complete' : '');
    reference.innerHTML =
      '<span class="checkout-promotion-jump-icon" aria-hidden="true">' +
        (complete ? promotionSuccessTickHtml() : '') +
      '</span>' +
      '<span class="checkout-promotion-jump-copy">' +
        '<strong>' + (complete
          ? (plural ? 'Rewards added' : 'Reward added')
          : (plural ? 'Promotional rewards available' : 'Promotional reward available')) + '</strong>' +
      '</span>' +
      '<a class="checkout-promotion-jump-link" ' +
        (complete && targetOffer ? 'data-promotion-expand="' + escapeHtml(targetOffer.id) + '" ' : 'data-promotion-jump ') +
        'href="#checkout-promotion-centre">' +
        (complete ? 'Change' : (plural ? 'Choose rewards' : 'Choose reward')) +
      '</a>';

    if (slot) {
      if (reference.parentNode !== slot) slot.appendChild(reference);
    } else if (!existing) {
      checkoutButton.parentNode.insertBefore(reference, checkoutButton);
    }
  }

  function renderPicker(active, cart) {
    var container = ensurePickerPlacement();
    if (!container) return;

    var pickerOffers = active.filter(function (offer) { return offer.rewardMode === 'picker'; });
    renderPickerReference(pickerOffers, cart);

    if (!pickerOffers.length) {
      container.innerHTML = '';
      return;
    }

    container.innerHTML = pickerOffers.map(function (offer) {
      var selection = pickerDraftSelection(offer, cart);
      var existingSelection = clampPickerSelection(offer, existingPickerSelection(offer, cart));
      var existingTotal = selectedPickerTotal(existingSelection);
      var maximum = Math.max(1, integer(offer.maxDiscountedQty, 1));
      var groups = groupRewardVariants(offer);
      var expanded = Boolean(state.pickerExpanded[offer.id]);
      var complete = existingTotal > 0 &&
        selectionIsSame(selection, existingSelection) &&
        !expanded;
      var heading = promotionTitle(offer);
      var eyebrow = promotionEyebrow(offer);

      if (complete) {
        return '<section class="checkout-promotion-panel is-complete is-collapsed" data-picker-offer="' + escapeHtml(offer.id) + '">' +
          '<div class="checkout-promotion-panel-header">' +
            '<div class="checkout-promotion-heading">' +
              '<span class="checkout-promotion-eyebrow">' + escapeHtml(eyebrow) + '</span>' +
              '<h3>' + escapeHtml(heading) + '</h3>' +
            '</div>' +
            '<span class="checkout-promotion-status is-complete">Reward added</span>' +
          '</div>' +
          '<div class="checkout-promotion-complete-row">' +
            '<span class="checkout-promotion-complete-tick" aria-hidden="true">' + promotionSuccessTickHtml() + '</span>' +
            '<span class="checkout-promotion-complete-copy">' +
              '<strong>Your reward is in the basket</strong>' +
              '<span>' + escapeHtml(pickerSelectionSummary(offer, existingSelection)) + '</span>' +
            '</span>' +
            '<button type="button" class="checkout-promotion-change-button" data-promotion-expand="' + escapeHtml(offer.id) + '">Change reward</button>' +
          '</div>' +
        '</section>';
      }

      var choices = groups.map(function (group) {
        var availableVariants = availableGroupVariants(group);
        var selectedVariant = selectedVariantForGroup(group, selection);
        var chosenVariant = chosenVariantForGroup(offer, group, selection);
        var selected = Boolean(selectedVariant);
        var disabled = !availableVariants.length;
        var optionHtml = '';
        var image = chosenVariant && chosenVariant.image ? chosenVariant.image : group.image;

        if (availableVariants.length > 1) {
          optionHtml = '<div class="prod-var checkout-promotion-variant-control">' +
            '<span class="checkout-promotion-variant-label">Choose an option</span>' +
            '<select class="dropdown prod-var-options checkout-promotion-choice-select" ' +
              'aria-label="Choose an option for ' + escapeHtml(group.productTitle) + '" ' +
              'data-promotion-variant-select ' +
              'data-promotion-offer="' + escapeHtml(offer.id) + '" ' +
              'data-promotion-product="' + escapeHtml(group.productId) + '"' +
              (disabled ? ' disabled' : '') + '>' +
              availableVariants.map(function (variant) {
                var id = normaliseId(variant.id);
                var cleanTitle = displayRewardVariantTitle(variant.title);
                var label = cleanTitle || 'Standard';
                return '<option value="' + escapeHtml(id) + '"' +
                  (chosenVariant && normaliseId(chosenVariant.id) === id ? ' selected' : '') +
                  '>' + escapeHtml(label) + '</option>';
              }).join('') +
            '</select>' +
          '</div>';
        } else if (chosenVariant) {
          var singleTitle = displayRewardVariantTitle(chosenVariant.title);
          optionHtml = singleTitle
            ? '<span class="prod-var">' + escapeHtml(singleTitle) + '</span>'
            : '<span class="prod-var checkout-promotion-empty-variant"></span>';
        } else {
          optionHtml = '<span class="prod-var checkout-promotion-empty-variant"></span>';
        }

        return '<div class="grid-item checkout-promotion-choice' +
          (selected ? ' is-selected' : '') +
          (disabled ? ' is-disabled' : '') +
          '" role="checkbox" tabindex="' + (disabled ? '-1' : '0') + '" ' +
          'aria-checked="' + (selected ? 'true' : 'false') + '" ' +
          'data-promotion-card ' +
          'data-promotion-offer="' + escapeHtml(offer.id) + '" ' +
          'data-promotion-product="' + escapeHtml(group.productId) + '" ' +
          'data-promotion-default-variant="' + escapeHtml(chosenVariant ? normaliseId(chosenVariant.id) : '') + '">' +
            '<span class="checkout-promotion-card-badge">Reward option</span>' +
            '<span class="checkout-promotion-choice-tick" aria-hidden="true">' + promotionSuccessTickHtml() + '</span>' +
            '<div class="product-card-image-wrap">' +
              '<div class="img-square">' +
                (image
                  ? '<img src="' + escapeHtml(image) + '" alt="">'
                  : '<span class="checkout-promotion-choice-image-placeholder"></span>') +
              '</div>' +
            '</div>' +
            '<div class="product-card-info">' +
              '<h5 class="product-card-title">' + escapeHtml(group.productTitle) + '</h5>' +
              optionHtml +
            '</div>' +
            rewardPriceHtml(offer, chosenVariant) +
        '</div>';
      }).join('');

      var buttonState = pickerButtonState(offer, selection, cart);
      var status = maximum === 1
        ? 'Choose one reward'
        : 'Choose up to ' + maximum + ' rewards';

      return '<section class="checkout-promotion-panel" data-picker-offer="' + escapeHtml(offer.id) + '">' +
        '<div class="checkout-promotion-panel-header">' +
          '<div class="checkout-promotion-heading">' +
            '<span class="checkout-promotion-eyebrow">' + escapeHtml(eyebrow) + '</span>' +
            '<h3>' + escapeHtml(heading) + '</h3>' +
            (offer.notificationText
              ? '<p>' + escapeHtml(offer.notificationText) + '</p>'
              : '') +
          '</div>' +
          '<span class="checkout-promotion-status">' + escapeHtml(status) + '</span>' +
        '</div>' +
        '<div class="checkout-promotion-picker-grid">' + choices + '</div>' +
        '<div class="checkout-promotion-picker-footer">' +
          '<span class="checkout-promotion-picker-count">' +
            buttonState.selectedTotal + ' of ' + buttonState.maximum + ' selected' +
          '</span>' +
          '<button type="button" class="button checkout-promotion-add-button" ' +
            'data-promotion-submit="' + escapeHtml(offer.id) + '"' +
            (buttonState.disabled ? ' disabled' : '') + '>' +
            escapeHtml(buttonState.label) +
          '</button>' +
        '</div>' +
      '</section>';
    }).join('');
  }

  function showToast(message, title) {
    if (!message) return;
    title = title || 'Promotion unlocked';
    var existing = document.querySelector('.checkout-promotion-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'checkout-promotion-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="checkout-promotion-toast__icon" aria-hidden="true">' + promotionSuccessTickHtml() + '</span>' +
      '<span class="checkout-promotion-toast__copy">' +
        '<strong>' + escapeHtml(title) + '</strong>' +
        '<span>' + escapeHtml(message) + '</span>' +
      '</span>';
    document.body.appendChild(toast);

    window.setTimeout(function () {
      if (!toast.parentNode) return;
      toast.classList.add('is-leaving');
      window.setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, 4700);
  }

  function showPendingToast() {
    try {
      var stored = sessionStorage.getItem('cmPromotionPendingToast');
      if (stored) {
        sessionStorage.removeItem('cmPromotionPendingToast');
        try {
          var pending = JSON.parse(stored);
          showToast(pending.message || '', pending.title || 'Promotion unlocked');
        } catch (parseError) {
          // Backwards-compatible with any plain-text value left by an older build.
          showToast(stored, 'Promotion unlocked');
        }
      }
    } catch (error) {
      // Ignore unavailable session storage.
    }
  }

  function notifyNewlyQualified(active, changed) {
    var activeIds = active.map(function (offer) { return offer.id; });

    if (isCartPage()) {
      active.forEach(function (offer) {
        var key = 'cmPromotionNotified:' + offer.id;
        var notified = false;
        try { notified = sessionStorage.getItem(key) === '1'; } catch (error) { notified = false; }
        if (notified) return;

        try { sessionStorage.setItem(key, '1'); } catch (error) { /* ignore */ }

        var toastTitle = offer.rewardMode === 'picker' ? 'Reward unlocked' : 'Promotion applied';
        var toastMessage = offer.notificationText || offer.displayName;

        if (changed) {
          try {
            sessionStorage.setItem('cmPromotionPendingToast', JSON.stringify({
              title: toastTitle,
              message: toastMessage
            }));
          } catch (error) { /* ignore */ }
        } else {
          showToast(toastMessage, toastTitle);
        }
      });
    }

    (state.data.offers || []).forEach(function (offer) {
      if (activeIds.indexOf(offer.id) !== -1) return;
      try { sessionStorage.removeItem('cmPromotionNotified:' + offer.id); } catch (error) { /* ignore */ }
    });
    state.lastActiveOfferIds = activeIds;
  }

  function activePromotionAttribute(active) {
    return active.map(function (offer) { return offer.id; }).join(',');
  }

  async function reconcile(options) {
    options = options || {};
    if (state.running) {
      state.rerun = true;
      return { changed: false, queued: true, activeOffers: state.activeOffers.slice() };
    }

    state.running = true;
    var result = { changed: false, queued: false, activeOffers: [] };

    try {
      state.data = parseData() || state.data;
      if (!state.data || !Array.isArray(state.data.offers)) return result;

      var cart = await fetchCart();
      var utmIds = await captureUtmId(cart);
      if (utmIds.length) cart = await fetchCart();
      state.lastCart = cart;
      state.utmIds = utmIds.slice();

      var active = activeOffers(cart, utmIds);
      active = dedupeSingleRewardFamilies(active, cart);
      state.activeOffers = active.slice();
      state.unsupportedNativeDiscounts = Boolean(
        state.data.nativeCheckout &&
        active.some(function (offer) { return number(offer.discountPercent, 0) > 0; })
      );
      result.activeOffers = active.slice();
      renderPicker(active, cart);

      var changed = false;

      if (state.unsupportedNativeDiscounts) {
        console.error('Checkout promotions are configured, but native checkout cannot honour theme-only line discounts. Use the custom draft-order checkout or a Shopify Discount Function.');
      } else {
        changed = await reconcileRewardLines(active, cart) || changed;
        if (changed) cart = await fetchCart();
        changed = await reconcileExistingDiscounts(active, cart) || changed;
      }

      var currentActive = String((cart.attributes && cart.attributes._active_promotions) || '');
      var nextActive = activePromotionAttribute(active);
      var activeAttributeChanged = currentActive !== nextActive;
      if (activeAttributeChanged) {
        await updateCartAttributes({ _active_promotions: nextActive });
      }

      var shouldRefreshCart = changed || activeAttributeChanged;
      var finalCart = shouldRefreshCart ? await fetchCart() : cart;
      state.lastCart = finalCart;

      result.changed = shouldRefreshCart;
      notifyNewlyQualified(active, shouldRefreshCart);
      renderPicker(active, finalCart);

      if (shouldRefreshCart) {
        document.dispatchEvent(new CustomEvent('cm:promotions-updated', { detail: { activeOffers: active } }));
        if (!options.suppressReload && (isCartPage() || options.forceReload)) {
          window.location.reload(true);
          return result;
        }
      }

      return result;
    } catch (error) {
      console.error('Promotion reconciliation failed:', error);
      result.error = error;
      return result;
    } finally {
      state.running = false;
      if (state.rerun) {
        state.rerun = false;
        window.setTimeout(function () { reconcile({ reason: 'queued' }); }, 50);
      }
    }
  }

  function currentPickerSelection(offer) {
    return clampPickerSelection(
      offer,
      state.pickerOverrides[offer.id] || existingPickerSelection(offer, state.lastCart || { items: [] })
    );
  }

  function currentPickerDraftSelection(offer) {
    return pickerDraftSelection(offer, state.lastCart || { items: [] });
  }

  function pickerGroupVariantIds(offer, productId) {
    var wantedProduct = normaliseId(productId);
    return (offer.rewardVariants || [])
      .filter(function (variant) {
        return normaliseId(variant.productId || variant.productTitle || variant.id) === wantedProduct;
      })
      .map(function (variant) { return normaliseId(variant.id); });
  }

  function rememberPickerVariant(offerId, productId, variantId) {
    if (!state.pickerChosenVariants[offerId]) state.pickerChosenVariants[offerId] = {};
    state.pickerChosenVariants[offerId][normaliseId(productId)] = normaliseId(variantId);
  }

  function choosePickerReward(offerId, productId, variantId) {
    if (!state.data) return;

    var offer = (state.data.offers || []).find(function (candidate) {
      return String(candidate.id) === String(offerId);
    });
    if (!offer) return;

    var chosenId = normaliseId(variantId);
    var chosenVariant = rewardVariantById(offer, chosenId);
    if (!chosenVariant || rewardVariantCapacity(chosenVariant) < 1) return;

    rememberPickerVariant(offer.id, productId, chosenId);

    var selection = currentPickerDraftSelection(offer);
    var groupIds = pickerGroupVariantIds(offer, productId);
    var selectedInGroup = groupIds.find(function (id) {
      return integer(selection[id], 0) > 0;
    });
    var maximum = Math.max(1, integer(offer.maxDiscountedQty, 1));

    groupIds.forEach(function (id) { selection[id] = 0; });

    if (selectedInGroup === chosenId) {
      state.pickerDrafts[offer.id] = clampPickerSelection(offer, selection);
      renderPicker(state.activeOffers, state.lastCart || { items: [] });
      return;
    }

    var totalAfterGroupRemoval = selectedPickerTotal(selection);
    if (!selectedInGroup && maximum > 1 && totalAfterGroupRemoval >= maximum) {
      showToast('You can choose up to ' + maximum + ' rewards.');
      renderPicker(state.activeOffers, state.lastCart || { items: [] });
      return;
    }

    if (maximum === 1) {
      Object.keys(selection).forEach(function (id) { selection[id] = 0; });
    }

    selection[chosenId] = 1;
    state.pickerDrafts[offer.id] = clampPickerSelection(offer, selection);
    renderPicker(state.activeOffers, state.lastCart || { items: [] });
  }

  function updatePickerVariant(offerId, productId, variantId) {
    if (!state.data) return;

    var offer = (state.data.offers || []).find(function (candidate) {
      return String(candidate.id) === String(offerId);
    });
    if (!offer) return;

    var chosenId = normaliseId(variantId);
    var chosenVariant = rewardVariantById(offer, chosenId);
    if (!chosenVariant || rewardVariantCapacity(chosenVariant) < 1) return;

    rememberPickerVariant(offer.id, productId, chosenId);

    var selection = currentPickerDraftSelection(offer);
    var groupIds = pickerGroupVariantIds(offer, productId);
    var groupWasSelected = groupIds.some(function (id) {
      return integer(selection[id], 0) > 0;
    });

    if (groupWasSelected) {
      groupIds.forEach(function (id) { selection[id] = 0; });
      selection[chosenId] = 1;
      state.pickerDrafts[offer.id] = clampPickerSelection(offer, selection);
    }

    renderPicker(state.activeOffers, state.lastCart || { items: [] });
  }

  async function commitPickerSelection(offerId, button) {
    if (!state.data || state.running) return;

    var offer = (state.data.offers || []).find(function (candidate) {
      return String(candidate.id) === String(offerId);
    });
    if (!offer) return;

    var selection = currentPickerDraftSelection(offer);
    var existing = clampPickerSelection(
      offer,
      existingPickerSelection(offer, state.lastCart || { items: [] })
    );

    if (selectionIsSame(selection, existing)) return;

    state.pickerOverrides[offer.id] = clampPickerSelection(offer, selection);
    state.pickerExpanded[offer.id] = false;

    if (button) {
      button.disabled = true;
      button.textContent = 'Updating basket...';
    }

    var result = await reconcile({
      reason: 'picker-submit',
      forceReload: isCartPage()
    });

    if (!result || !result.changed) {
      if (button) button.disabled = false;
      renderPicker(state.activeOffers, state.lastCart || { items: [] });
    }
  }

  function selectedCardVariant(card) {
    var select = card.querySelector('[data-promotion-variant-select]');
    return select ? select.value : card.getAttribute('data-promotion-default-variant');
  }

  document.addEventListener('click', function (event) {
    var expand = event.target.closest('[data-promotion-expand]');
    if (expand) {
      event.preventDefault();
      var expandOfferId = expand.getAttribute('data-promotion-expand');
      state.pickerExpanded[expandOfferId] = true;
      renderPicker(state.activeOffers, state.lastCart || { items: [] });

      window.requestAnimationFrame(function () {
        var panel = Array.prototype.find.call(
          document.querySelectorAll('[data-picker-offer]'),
          function (candidate) {
            return String(candidate.getAttribute('data-picker-offer')) === String(expandOfferId);
          }
        );
        if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return;
    }

    var jump = event.target.closest('[data-promotion-jump]');
    if (jump) {
      var target = document.getElementById('checkout-promotion-centre');
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    var submit = event.target.closest('[data-promotion-submit]');
    if (submit) {
      event.preventDefault();
      commitPickerSelection(submit.getAttribute('data-promotion-submit'), submit);
      return;
    }

    if (event.target.closest('[data-promotion-variant-select]')) return;

    var card = event.target.closest('[data-promotion-card]');
    if (!card || card.classList.contains('is-disabled')) return;

    event.preventDefault();
    choosePickerReward(
      card.getAttribute('data-promotion-offer'),
      card.getAttribute('data-promotion-product'),
      selectedCardVariant(card)
    );
  });

  document.addEventListener('keydown', function (event) {
    if (event.target.closest('[data-promotion-variant-select]')) return;

    var card = event.target.closest('[data-promotion-card]');
    if (!card || card.classList.contains('is-disabled')) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    choosePickerReward(
      card.getAttribute('data-promotion-offer'),
      card.getAttribute('data-promotion-product'),
      selectedCardVariant(card)
    );
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-promotion-variant-select]');
    if (!select) return;

    updatePickerVariant(
      select.getAttribute('data-promotion-offer'),
      select.getAttribute('data-promotion-product'),
      select.value
    );
  });

  document.addEventListener('cm:cart-changed', function () {
    reconcile({ reason: 'cart-changed' });
  });

  function backendDiscountCodes() {
    var appliedOfferIds = unique(
      ((state.lastCart && state.lastCart.items) || [])
        .filter(function (item) {
          var props = propertiesOf(item);
          return props._offer_id && integer(props._offer_discount_qty, 0) > 0;
        })
        .map(function (item) { return String(propertiesOf(item)._offer_id); })
    );

    return unique(
      state.activeOffers
        .filter(function (offer) {
          return number(offer.discountPercent, 0) > 0 &&
            appliedOfferIds.indexOf(String(offer.id)) !== -1;
        })
        .map(function (offer) {
          return String(offer.code || offer.id || '').trim().toUpperCase();
        })
        .filter(Boolean)
    );
  }

  window.CMCheckoutPromotions = {
    reconcile: reconcile,
    showToast: showToast,
    getActiveOffers: function () { return state.activeOffers.slice(); },
    getBackendDiscountCodes: backendDiscountCodes,
    hasUnsupportedNativeDiscounts: function () { return state.unsupportedNativeDiscounts; }
  };

  function init() {
    state.data = parseData();
    showPendingToast();
    if (!state.data) return;
    reconcile({ reason: 'page-load' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

(function() {
  if (window.cmDocumentDrawerScroll) return;

  var activeScroller = null;
  var savedPageY = 0;
  var scrollFrame = null;

  function getDocumentScroll() {
    return window.pageYOffset ||
      document.documentElement.scrollTop ||
      0;
  }

  function getDrawerScrollRange() {
    if (!activeScroller) return 0;

    return Math.max(
      0,
      activeScroller.scrollHeight - activeScroller.clientHeight
    );
  }

  function updateRange() {
    if (!activeScroller) return;

    var range = getDrawerScrollRange();

    document.documentElement.style.setProperty(
      '--cm-drawer-scroll-range',
      range + 'px'
    );

    var currentY = getDocumentScroll();
    var correctedY = Math.max(0, Math.min(currentY, range));

    if (Math.abs(currentY - correctedY) > 1) {
      window.scrollTo(0, correctedY);
    }

    activeScroller.scrollTop = correctedY;
  }

  function syncDrawerToDocument() {
    if (!activeScroller || scrollFrame) return;

    scrollFrame = requestAnimationFrame(function() {
      scrollFrame = null;

      if (!activeScroller) return;

      activeScroller.scrollTop = Math.min(
        getDocumentScroll(),
        getDrawerScrollRange()
      );
    });
  }

  function open(scroller) {
    if (!scroller) return;

    /*
      Remember where the customer was on the actual page.
    */
    savedPageY = getDocumentScroll();

    activeScroller = scroller;
    activeScroller.scrollTop = 0;

    document.body.style.setProperty(
      '--cm-locked-page-y',
      (-savedPageY) + 'px'
    );

    document.documentElement.classList.add(
      'cm-document-drawer-scroll'
    );

    document.body.classList.add(
      'cm-document-drawer-scroll'
    );

    requestAnimationFrame(function() {
      updateRange();

      /*
        The document scrollbar now starts at the top of the drawer.
      */
      window.scrollTo(0, 0);
      activeScroller.scrollTop = 0;

      /*
        Recheck once the drawer has painted.
      */
      requestAnimationFrame(updateRange);
    });
  }

  function close() {
    if (!activeScroller) return;

    var restorePageY = savedPageY;

    activeScroller.scrollTop = 0;
    activeScroller = null;

    document.documentElement.classList.remove(
      'cm-document-drawer-scroll'
    );

    document.body.classList.remove(
      'cm-document-drawer-scroll'
    );

    document.documentElement.style.removeProperty(
      '--cm-drawer-scroll-range'
    );

    document.body.style.removeProperty(
      '--cm-locked-page-y'
    );

    /*
      Return the normal page to exactly where it was before
      the drawer was opened.
    */
    window.scrollTo(0, restorePageY);
  }

  function refresh() {
    if (activeScroller) {
      updateRange();
    }
  }

  window.addEventListener(
    'scroll',
    syncDrawerToDocument,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    refresh
  );

  /*
    Recalculate if an image loads and changes drawer height.
  */
  document.addEventListener(
    'load',
    function() {
      if (activeScroller) {
        updateRange();
      }
    },
    true
  );

  window.cmDocumentDrawerScroll = {
    open: open,
    close: close,
    refresh: refresh
  };
})();

